import React, { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom"; // SIP_WO_FLOATING_CHAT_V5_PORTAL


import "./EngineeringWO.layout.fix.css";
const API_BASE = window.location.pathname.startsWith("/staging")
  ? "/staging-api/eng-wo"
  : "/api/eng-wo";

// SIP_WO_WORKFLOW_V2_FRONTEND
const API_V2 = window.location.pathname.startsWith("/staging")
  ? "/staging-api/eng-wo-v2"
  : "/api/eng-wo-v2";

const emptyCreate = {
  urgency: "NORMAL", // internal legacy; UI Prioritas ditentukan PPIC
  kategori: "BO",
  area_dies: "DIMESIN",
  part_ref_id: "",
  nama_part: "",
  line: "",
  kode_part: "",
  proses: "BENDING",
  uraian_masalah: "",
};

const emptyEng = {
  analisa_penyebab: "",
  tindakan_perbaikan: "",
  grinding_die_decision: "",
  grinding_die_flag: false,
  grinding_die: "",
  grinding_punch_decision: "",
  grinding_punch_flag: false,
  grinding_punch: "",
  ganti_komponen_decision: "",
  ganti_komponen_flag: false,
  ganti_komponen: "",
  tanggal_mulai: "",
  jam_mulai: "",
  tanggal_selesai: "",
  jam_selesai: "",
  hasil: "OK",
};

function getStoredUser() {
  const keys = ["user", "auth_user", "currentUser", "loginUser"];
  for (const key of keys) {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) continue;
      const parsed = JSON.parse(raw);
      if (parsed) return parsed;
    } catch (_) {}
  }

  return {
    username:
      localStorage.getItem("username") ||
      localStorage.getItem("user_name") ||
      "admin",
    role: localStorage.getItem("role") || "admin",
  };
}

function normalizePermissions(user) {
  const possible = [
    user?.permissions,
    user?.permission,
    user?.menus,
    user?.menu_access,
    user?.access,
    localStorage.getItem("permissions"),
    localStorage.getItem("user_permissions"),
    localStorage.getItem("menu_access"),
  ];

  const out = [];

  possible.forEach((raw) => {
    if (!raw) return;

    if (Array.isArray(raw)) {
      raw.forEach((x) => {
        if (typeof x === "string") out.push(x);
        else if (x?.key) out.push(String(x.key));
        else if (x?.permission) out.push(String(x.permission));
        else if (x?.value) out.push(String(x.value));
        else if (x?.name) out.push(String(x.name));
      });
      return;
    }

    if (typeof raw === "string") {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          parsed.forEach((x) => {
            if (typeof x === "string") out.push(x);
            else if (x?.key) out.push(String(x.key));
            else if (x?.permission) out.push(String(x.permission));
            else if (x?.value) out.push(String(x.value));
            else if (x?.name) out.push(String(x.name));
          });
          return;
        }
      } catch (_) {}

      raw.split(",").map((x) => x.trim()).filter(Boolean).forEach((x) => out.push(x));
    }
  });

  return Array.from(new Set(out));
}

function getToken() {
  return (
    localStorage.getItem("token") ||
    localStorage.getItem("authToken") ||
    localStorage.getItem("access_token") ||
    ""
  );
}

function statusClass(status) {
  const s = String(status || "").toUpperCase();
  if (s === "OPEN") return "wo-badge wo-open";
  if (s === "PROGRESS") return "wo-badge wo-progress";
  if (s === "RESOLVED") return "wo-badge wo-resolved";
  if (s === "CLOSED") return "wo-badge wo-closed";
  return "wo-badge";
}

function optValues(options, key, fallback = []) {
  const arr = options?.[key] || [];
  const values = arr.map((x) => x.value || x.label).filter(Boolean);
  return values.length ? values : fallback;
}

function fmtDate(v) {
  if (!v) return "-";
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  return s;
}

function fmtTime(v) {
  if (!v) return "";
  const s = String(v);
  if (s.includes("T")) {
    const d = new Date(s);
    if (!Number.isNaN(d.getTime())) {
      return d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });
    }
  }
  return s.slice(0, 5);
}

function fmtDateTime(date, time, fallback) {
  if (date || time) return `${fmtDate(date)} ${fmtTime(time)}`.trim();
  if (!fallback) return "-";
  const d = new Date(fallback);
  if (Number.isNaN(d.getTime())) return String(fallback);
  return d.toLocaleString("id-ID");
}


/* SIP_WO_DATE_PARALLEL_V11 */
if (typeof window !== "undefined") {
  window.__SIP_WO_DATE_PARALLEL_V11__ = "SIP_WO_DATE_PARALLEL_V11";
}

function sipWoLocalDateV11(value) {
  if (!value) return "";

  const raw = String(value).trim();

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return raw;
  }

  const d = new Date(value);

  if (!Number.isNaN(d.getTime())) {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }

  return raw.slice(0, 10);
}
/* END SIP_WO_DATE_PARALLEL_V11 */

export default function EngineeringWO() {
  const user = useMemo(() => getStoredUser(), []);
  const permissions = useMemo(() => normalizePermissions(user), [user]);
  const username = user?.username || user?.name || "admin";
  const isAdmin = String(user?.role || "").toLowerCase() === "admin" || String(username).toLowerCase() === "admin";

  


  const hasPerm = (perm) => isAdmin || permissions.includes(perm);

  const tabs = useMemo(() => {
    const data = [
      { key: "dashboard", label: "Dashboard", perm: "engineering.wo.dashboard", fallback: "engineering.wo.view" },
      { key: "list", label: "List WO", perm: "engineering.wo.list", fallback: "engineering.wo.create" },
      { key: "create", label: "Input Produksi", perm: "engineering.wo.production.view", fallback: "engineering.wo.list" },
      { key: "ppic", label: "PPIC", perm: "engineering.wo.ppic.view" },
      { key: "engineering", label: "Engineering", perm: "engineering.wo.engineering" },
      { key: "quality", label: "Quality", perm: "engineering.wo.quality.view" },
{ key: "admin", label: "Master Admin", perm: "engineering.wo.admin" },
      { key: "print", label: "Laporan / Print", perm: "engineering.wo.print" },
    ];
    return data.filter((x) => hasPerm(x.perm) || (x.fallback && hasPerm(x.fallback)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions.join(","), isAdmin]);

  const [tab, setTab] = useState("dashboard");

  // SIP_WO_TAB_FILTER_V3 - filter terpisah untuk Input Produksi / PPIC / Engineering / Quality
  const emptyWorkflowTabFilterV3 = {
    q: "",
    urgency: "",
    kategori: "",
    area_dies: "",
    line: "",
    proses: "",
    date_from: "",
    date_to: "",
  };

  const [workflowTabFiltersV3, setWorkflowTabFiltersV3] = useState({
    create: { ...emptyWorkflowTabFilterV3 },
    ppic: { ...emptyWorkflowTabFilterV3 },
    engineering: { ...emptyWorkflowTabFilterV3 },
    quality: { ...emptyWorkflowTabFilterV3 },
  });

  const updateWorkflowTabFilterV3 = (tabKey, key, value) => {
    setWorkflowTabFiltersV3((prev) => ({
      ...prev,
      [tabKey]: { ...prev[tabKey], [key]: value },
    }));
  };

  const resetWorkflowTabFilterV3 = (tabKey) => {
    setWorkflowTabFiltersV3((prev) => ({
      ...prev,
      [tabKey]: { ...emptyWorkflowTabFilterV3 },
    }));
  };

  const [list, setList] = useState([]);
  const [options, setOptions] = useState({});
  const [parts, setParts] = useState([]);
  const [partQ, setPartQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const [ppicRowsV2, setPpicRowsV2] = useState([]);
  const [qualityRowsV2, setQualityRowsV2] = useState([]);
  const [machineRowsV2, setMachineRowsV2] = useState([]);
  const [machinePickerWoV2, setMachinePickerWoV2] = useState(null);
  const [machinePickerIdV2, setMachinePickerIdV2] = useState("");
  const [unreadV2, setUnreadV2] = useState({
    PRODUCTION: 0,
    PPIC: 0,
    ENGINEERING: 0,
    QUALITY: 0,
    TOTAL: 0,
  });
  const [chatWoV2, setChatWoV2] = useState(null);
  const [chatDefaultRoleV2, setChatDefaultRoleV2] = useState("ENGINEERING");
  const [fileWoV2, setFileWoV2] = useState(null);
  const [fileUploadAllowedV2, setFileUploadAllowedV2] = useState(false);
  const [historyWoV2, setHistoryWoV2] = useState(null);

  const [filters, setFilters] = useState({
    status: "",
    workflow_stage: "",
    urgency: "",
    kategori: "",
    area_dies: "",
    line: "",
    proses: "",
    ppic_status: "",
    quality_status: "",
    hasil: "",
    created_by: "",
    ppic_approver: "",
    engineering_pic: "",
    quality_approver: "",
    grinding_die: "",
    grinding_punch: "",
    ganti_komponen: "",
    mttr_min: "",
    mttr_max: "",
    overdue: "",
    date_from: "",
    date_to: "",
    q: "",
  });

  const [form, setForm] = useState(emptyCreate);
  const [editingProduction, setEditingProduction] = useState(null);
  const [selected, setSelected] = useState(null);
  const [engForm, setEngForm] = useState(emptyEng);
  const [showDie, setShowDie] = useState(false);
  const [showPunch, setShowPunch] = useState(false);
  const [showComp, setShowComp] = useState(false);

  const [master, setMaster] = useState({
    id: null,
    group_key: "analisa_penyebab",
    value: "",
  });

  const [machineMasterV2, setMachineMasterV2] = useState({
    id: null,
    machine_id: "",
    machine_name: "",
    line: "",
  });

  const headers = () => ({
    "Content-Type": "application/json",
    Authorization: getToken() ? `Bearer ${getToken()}` : "",
    "X-User-Name": username,
    "X-User-Id": user?.id || "",
  });

  async function api(path, opts = {}) {
    const res = await fetch(`${API_BASE}${path}`, {
      ...opts,
      headers: { ...headers(), ...(opts.headers || {}) },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.ok === false) {
      throw new Error(json.message || `HTTP ${res.status}`);
    }
    return json;
  }

  async function apiV2(path, opts = {}) {
    const res = await fetch(`${API_V2}${path}`, {
      ...opts,
      headers: { ...headers(), ...(opts.headers || {}) },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.ok === false) {
      throw new Error(json.message || `HTTP ${res.status}`);
    }
    return json;
  }

  async function loadWorkflowV2() {
    const jobs = [];

    if (hasPerm("engineering.wo.ppic.view")) {
      jobs.push(
        apiV2("/pending/ppic")
          .then((x) => setPpicRowsV2(x.data || []))
          .catch((e) => setMsg(`Gagal load PPIC: ${e.message}`))
      );
    } else {
      setPpicRowsV2([]);
    }

    if (hasPerm("engineering.wo.quality.view")) {
      jobs.push(
        apiV2("/pending/quality")
          .then((x) => setQualityRowsV2(x.data || []))
          .catch((e) => setMsg(`Gagal load Quality: ${e.message}`))
      );
    } else {
      setQualityRowsV2([]);
    }

    await Promise.all(jobs);
  }

  async function loadUnreadV2() {
    if (!hasPerm("engineering.wo.chat") && !hasPerm("engineering.wo.view")) {
      setUnreadV2({
        PRODUCTION: 0,
        PPIC: 0,
        ENGINEERING: 0,
        QUALITY: 0,
        TOTAL: 0,
      });
      return;
    }

    try {
      const x = await apiV2("/chat-center-multi/unread");
      setUnreadV2(x.data || {});
    } catch (_) {}
  }

  async function loadOptions() {
    const json = await api("/options");
    setOptions(json.data || {});
  }

  async function loadMachinesV2() {
    if (!hasPerm("engineering.wo.production.assign") && !hasPerm("engineering.wo.admin")) {
      setMachineRowsV2([]);
      return;
    }

    try {
      const json = await apiV2("/machines");
      setMachineRowsV2(json.data || []);
    } catch (e) {
      setMsg(`Gagal load master mesin: ${e.message}`);
    }
  }

  async function loadList(extra = {}) {
    setLoading(true);
    try {
      const qs = new URLSearchParams();
      const merged = { ...filters, ...extra };
      Object.entries(merged).forEach(([k, v]) => {
        if (v) qs.set(k, v);
      });
      qs.set("limit", "50000");
      const json = await apiV2(`/list?${qs.toString()}`);
      setList(json.data || []);
    } catch (e) {
      setMsg(`Gagal load data: ${e.message}`);
    } finally {
      setLoading(false);
    }
  }

  async function loadParts() {
    try {
      const json = await api(`/parts?q=${encodeURIComponent(partQ || "")}`);
      setParts(json.data || []);
    } catch (e) {
      setMsg(`Gagal ambil part OEE: ${e.message}`);
    }
  }

  useEffect(() => {
    loadOptions();
    loadList();
    loadParts();
    loadWorkflowV2();
    loadMachinesV2();
    loadUnreadV2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // === SIP_WO_PART_AUTO_SEARCH_R12 ===
  useEffect(() => {
    const timer = setTimeout(() => {
      loadParts();
    }, 350);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partQ]);
  // === END SIP_WO_PART_AUTO_SEARCH_R12 ===

  useEffect(() => {
    if (!tabs.length) return;
    if (!tabs.find((x) => x.key === tab)) setTab(tabs[0].key);
  }, [tabs, tab]);

  const counts = useMemo(() => {
    const c = { OPEN: 0, PROGRESS: 0, RESOLVED: 0, CLOSED: 0, TOTAL: list.length };
    list.forEach((r) => {
      const s = String(r.status_wo || "").toUpperCase();
      if (c[s] !== undefined) c[s] += 1;
    });
    return c;
  }, [list]);

  const engineeringRows = useMemo(
    () => list.filter((r) => {
      const stage = String(r.workflow_stage || "").toUpperCase();
      if (stage) {
        return [
          "READY_ENGINEERING",
          "WAITING_PPIC",
          "ENGINEERING_PROCESS",
          "ENGINEERING_REWORK",
        ].includes(stage);
      }
      return ["OPEN", "PROGRESS"].includes(
        String(r.status_wo || "").toUpperCase()
      );
    }),
    [list]
  );

  const productionCloseRows = useMemo(
    () => list.filter((r) => {
      const stage = String(r.workflow_stage || "").toUpperCase();
      if (stage === "PPIC_RETURNED") return true;
      if (stage === "WAITING_PRODUCTION_MACHINE") return true;
      if (stage === "QUALITY_APPROVED") return true;
      if (!stage) {
        return ["OPEN", "RESOLVED"].includes(
          String(r.status_wo || "").toUpperCase()
        );
      }
      return false;
    }),
    [list]
  );

  // SIP_WO_TAB_FILTER_V3
  const matchWorkflowTabFilterV3 = (r, f) => {
    if (!r) return false;
    const norm = (v) => String(v ?? "").trim().toLowerCase();
    const eq = (value, wanted) => !wanted || norm(value) === norm(wanted);

    if (!eq(r.urgency, f.urgency)) return false;
    if (!eq(r.kategori, f.kategori)) return false;
    if (!eq(r.area_dies, f.area_dies)) return false;
    if (!eq(r.proses, f.proses)) return false;

    if (f.line && !norm(r.line).includes(norm(f.line))) return false;

    const rowDate = sipWoLocalDateV11(
      r.tanggal_masuk || r.created_at || r.createdAt || ""
    );
    if (f.date_from && (!rowDate || rowDate < f.date_from)) return false;
    if (f.date_to && (!rowDate || rowDate > f.date_to)) return false;

    if (f.q) {
      const haystack = [
        r.wo_no,
        r.status_wo,
        r.workflow_stage,
        r.urgency,
        r.kategori,
        r.area_dies,
        r.nama_part,
        r.kode_part,
        r.line,
        r.proses,
        r.machine_id,
        r.uraian_masalah,
        r.analisa_penyebab,
        r.tindakan_perbaikan,
        r.diserahkan_produksi_by,
        r.ppic_approved_by,
        r.diterima_engineering_by,
        r.quality_approved_by,
      ].map(norm).join(" ");
      if (!haystack.includes(norm(f.q))) return false;
    }

    return true;
  };

  const productionCloseRowsFilteredV3 = useMemo(
    () => productionCloseRows.filter((r) => matchWorkflowTabFilterV3(r, workflowTabFiltersV3.create)),
    [productionCloseRows, workflowTabFiltersV3.create]
  );

  const ppicRowsFilteredV3 = useMemo(
    () => ppicRowsV2.filter((r) => matchWorkflowTabFilterV3(r, workflowTabFiltersV3.ppic)),
    [ppicRowsV2, workflowTabFiltersV3.ppic]
  );

  const engineeringRowsFilteredV3 = useMemo(
    () => engineeringRows.filter((r) => matchWorkflowTabFilterV3(r, workflowTabFiltersV3.engineering)),
    [engineeringRows, workflowTabFiltersV3.engineering]
  );

  const qualityRowsFilteredV3 = useMemo(
    () => qualityRowsV2.filter((r) => matchWorkflowTabFilterV3(r, workflowTabFiltersV3.quality)),
    [qualityRowsV2, workflowTabFiltersV3.quality]
  );
  // END SIP_WO_TAB_FILTER_V3

  const urgencyOptions = Array.from(
    new Set([
      ...optValues(options, "urgency", []),
      "LOW",
      "NORMAL",
      "HIGH",
      "URGENT",
      "CRITICAL",
    ])
  );
  const kategoriOptions = optValues(options, "kategori", ["BO", "MAN POWER"]);
  const areaOptions = optValues(options, "area_dies", ["DIMESIN", "DIMEJA"]);
  const prosesOptions = optValues(options, "proses", ["BENDING", "BLANK"]);
  const analisaOptions = optValues(options, "analisa_penyebab", ["DIE TUMPUL", "PUNCH AUS", "SETTING DIES TIDAK SESUAI", "LAIN-LAIN"]);

  function selectPart(p) {
    setForm((f) => ({
      ...f,
      part_ref_id: p.id || "",
      nama_part: p.nama_part || "",
      kode_part: p.kode_part || "",
      line: p.line || "",
      proses:
        p.proses && ["BENDING", "BLANK"].includes(String(p.proses).toUpperCase())
          ? String(p.proses).toUpperCase()
          : f.proses,
    }));
  }


  async function saveWO(e) {
    e.preventDefault();
    setMsg("");

    try {
      if (editingProduction) {
        await api(`/${editingProduction.id}`, {
          method: "PUT",
          body: JSON.stringify({ ...form, urgency: "NORMAL" }),
        });

        if (
          String(editingProduction.workflow_stage || "").toUpperCase() ===
          "PPIC_RETURNED"
        ) {
          await apiV2(`/production/${editingProduction.id}/resubmit`, {
            method: "POST",
            body: JSON.stringify({}),
          });
        }

        setMsg(
          `WO ${editingProduction.wo_no} berhasil diperbarui dan dikirim ke PPIC`
        );
        setEditingProduction(null);
        setForm(emptyCreate);
        await loadList();
        setTab("list");
        return;
      }

      /* SIP_WO_PPIC_IMMEDIATE_V14_FRONTEND */
      const createPayload = {
        ...form,
        urgency: "NORMAL"
      };

      /*
       * Simpan record legacy terlebih dahulu.
       * Setelah berhasil, WAJIB langsung set WAITING_PPIC
       * sebelum form dibersihkan atau user dipindah tab.
       */
      const json = await api("/", {
        method: "POST",
        body: JSON.stringify(createPayload),
      });

      const createdId =
        json?.data?.id ||
        json?.data?.insertId ||
        json?.id ||
        json?.insertId ||
        null;

      const createdWoNo =
        json?.data?.wo_no ||
        json?.wo_no ||
        json?.data?.data?.wo_no ||
        "";

      const approval = await apiV2(
        "/production/start-approval",
        {
          method: "POST",
          body: JSON.stringify({
            id: createdId,
            wo_id: createdId,
            wo_no: createdWoNo,
            lookup: {
              nama_part: createPayload.nama_part,
              kode_part: createPayload.kode_part,
              line: createPayload.line,
              proses: createPayload.proses,
              uraian_masalah: createPayload.uraian_masalah,
              kategori: createPayload.kategori,
              area_dies: createPayload.area_dies,
            },
          }),
        }
      );

      const submittedWO =
        approval?.data?.wo_no ||
        createdWoNo ||
        "";

      setMsg(
        `WO ${submittedWO} berhasil dibuat dan langsung menunggu approval PPIC.`
      );

      setForm(emptyCreate);

      await loadList();

      /* SIP_WO_PPIC_REFRESH_AFTER_SAVE_V15 */
      await loadWorkflowV2();
      await loadUnreadV2();
      await loadWorkflowV2();

      /*
       * Admin/PPIC langsung dapat melihat badge/tab PPIC.
       * Produksi yang tidak punya akses PPIC tetap diarahkan ke List WO.
       */
      if (hasPerm("engineering.wo.ppic.view")) {
        setTab("ppic");
      } else {
        setTab("list");
      }
    } catch (e2) {
      setMsg(`Gagal simpan WO: ${e2.message}`);
    }
  }

  function openProductionEdit(row) {
    if (String(row.status_wo || "").toUpperCase() !== "OPEN") {
      setMsg("WO hanya bisa diedit Produksi saat status masih OPEN.");
      return;
    }

    setEditingProduction(row);
    setForm({
      urgency: "NORMAL",
      kategori: row.kategori || "BO",
      area_dies: row.area_dies || "DIMESIN",
      part_ref_id: row.part_ref_id || "",
      nama_part: row.nama_part || "",
      line: row.line || "",
      kode_part: row.kode_part || "",
      proses: row.proses || "BENDING",
      uraian_masalah: row.uraian_masalah || "",
    });

    setTab("create");
    setTimeout(() => window.scrollTo({ top: 0, behavior: "smooth" }), 100);
  }

  function cancelProductionEdit() {
    setEditingProduction(null);
    setForm(emptyCreate);
  }

  async function openEngineering(row) {
    let target = row;

    try {
      if (!row.diterima_engineering_by) {
        await api(`/${row.id}/accept-engineering-manual`, {
          method: "POST",
          body: JSON.stringify({}),
        });

        await apiV2(`/engineering/${row.id}/start`, {
          method: "POST",
          body: JSON.stringify({}),
        });

        const fresh = await api(`/${row.id}`);
        target = fresh.data || row;
        await loadList();
      }
    } catch (e) {
      setMsg(`Gagal set Diterima Engineering: ${e.message}`);
    }

    if (
      ["WAITING_PPIC", "READY_ENGINEERING", "ENGINEERING_REWORK"].includes(
        String(target.workflow_stage || "").toUpperCase()
      )
    ) {
      try {
        await apiV2(`/engineering/${target.id}/start`, {
          method: "POST",
          body: JSON.stringify({}),
        });

        const freshV2 = await apiV2(
          `/list?q=${encodeURIComponent(target.wo_no || "")}&limit=20`
        );

        target =
          (freshV2.data || []).find(
            (x) => Number(x.id) === Number(target.id)
          ) || target;
      } catch (e) {
        setMsg(`Gagal update workflow Engineering: ${e.message}`);
      }
    }

    setSelected(target);
    setEngForm({
      analisa_penyebab: target.analisa_penyebab || "",
      tindakan_perbaikan: target.tindakan_perbaikan || "",
      grinding_die_decision:
        target.grinding_die_decision ||
        (target.grinding_die_flag || target.grinding_die ? "YA" : ""),
      grinding_die_flag: !!target.grinding_die_flag,
      grinding_die: target.grinding_die || "",
      grinding_punch_decision:
        target.grinding_punch_decision ||
        (target.grinding_punch_flag || target.grinding_punch ? "YA" : ""),
      grinding_punch_flag: !!target.grinding_punch_flag,
      grinding_punch: target.grinding_punch || "",
      ganti_komponen_decision:
        target.ganti_komponen_decision ||
        (target.ganti_komponen_flag || target.ganti_komponen ? "YA" : ""),
      ganti_komponen_flag: !!target.ganti_komponen_flag,
      ganti_komponen: target.ganti_komponen || "",
      tanggal_mulai: target.tanggal_mulai ? sipWoLocalDateV11(target.tanggal_mulai) : "",
      jam_mulai: target.jam_mulai ? String(target.jam_mulai).slice(0, 5) : "",
      tanggal_selesai: target.tanggal_selesai ? sipWoLocalDateV11(target.tanggal_selesai) : "",
      jam_selesai: target.jam_selesai ? String(target.jam_selesai).slice(0, 5) : "",
      hasil: target.hasil || "OK",
    });

    setShowDie(!!target.tindakan_perbaikan);
    setShowPunch(!!target.tindakan_perbaikan);
    setShowComp(!!target.tindakan_perbaikan);
  }


  async function acceptEngineering(row = selected) {
    if (!row) return;
    await api(`/${row.id}/accept-engineering-manual`, {
      method: "POST",
      body: JSON.stringify(engForm),
    });
    setMsg("WO diterima dan diproses Engineering");
    await loadList();
    const fresh = await api(`/${row.id}`);
    setSelected(fresh.data);
    openEngineering(fresh.data);
  }

  async function saveEngineeringProgress() {
    if (!selected) return;
    await api(`/${selected.id}/engineering-update-manual`, {
      method: "POST",
      body: JSON.stringify(engForm),
    });

    await apiV2(`/engineering/${selected.id}/save`, {
      method: "POST",
      body: JSON.stringify({}),
    });

    setMsg("Progress Engineering tersimpan");
    await loadList();
    const fresh = await api(`/${selected.id}`);
    setSelected(fresh.data);
  }

  async function closeEngineering() {
    if (!selected) return;

    if (!engForm.tanggal_mulai || !engForm.jam_mulai || !engForm.tanggal_selesai || !engForm.jam_selesai) {
      setMsg("Mulai dan Selesai Engineering wajib diisi manual sebelum Close Engineering.");
      return;
    }

    const manualStart = new Date(`${engForm.tanggal_mulai}T${engForm.jam_mulai}`);
    const manualEnd = new Date(`${engForm.tanggal_selesai}T${engForm.jam_selesai}`);

    if (
      Number.isNaN(manualStart.getTime()) ||
      Number.isNaN(manualEnd.getTime()) ||
      manualEnd < manualStart
    ) {
      setMsg("Waktu Selesai Engineering tidak boleh lebih kecil dari waktu Mulai.");
      return;
    }

    const dieDecision = String(engForm.grinding_die_decision || "").toUpperCase();
    const punchDecision = String(engForm.grinding_punch_decision || "").toUpperCase();
    const compDecision = String(engForm.ganti_komponen_decision || "").toUpperCase();

    const validDecision = (v) => ["YA", "TIDAK"].includes(v);

    if (!engForm.analisa_penyebab || !engForm.tindakan_perbaikan) {
      setMsg("Analisa Penyebab dan Tindakan Perbaikan wajib diisi sebelum Close Engineering.");
      return;
    }

    if (!validDecision(dieDecision) || !validDecision(punchDecision) || !validDecision(compDecision)) {
      setMsg("Grinding DIE, Grinding PUNCH, dan Ganti Komponen wajib dipilih Ya atau Tidak sebelum Close Engineering.");
      return;
    }

    if (dieDecision === "YA" && !String(engForm.grinding_die || "").trim()) {
      setMsg("Isi Grinding DIE wajib diisi jika pilih Ya.");
      return;
    }

    if (punchDecision === "YA" && !String(engForm.grinding_punch || "").trim()) {
      setMsg("Isi Grinding PUNCH wajib diisi jika pilih Ya.");
      return;
    }

    if (compDecision === "YA" && !String(engForm.ganti_komponen || "").trim()) {
      setMsg("Isi Ganti Komponen wajib diisi jika pilih Ya.");
      return;
    }

    await api(`/${selected.id}/close-engineering-manual`, {
      method: "POST",
      body: JSON.stringify({
        ...engForm,
        grinding_die_flag: dieDecision === "YA",
        grinding_punch_flag: punchDecision === "YA",
        ganti_komponen_flag: compDecision === "YA",
      }),
    });

    await apiV2(`/engineering/${selected.id}/mark-production-machine`, {
      method: "POST",
      body: JSON.stringify({}),
    });

    setMsg(
      "Engineering CLOSE. WO masuk ke Input Produksi untuk pilih ID Mesin sebelum Quality."
    );
    setSelected(null);
    await loadList();
    await loadWorkflowV2();
  }


  function openMachinePickerV2(row) {
    setMachinePickerWoV2(row);
    setMachinePickerIdV2(row?.machine_master_id ? String(row.machine_master_id) : "");
  }

  async function confirmMachinePickerV2() {
    if (!machinePickerWoV2) return;
    if (!machinePickerIdV2) {
      setMsg("Pilih ID Mesin terlebih dahulu.");
      return;
    }

    const result = await apiV2(`/production/${machinePickerWoV2.id}/select-machine`, {
      method: "POST",
      body: JSON.stringify({ machine_master_id: Number(machinePickerIdV2) }),
    });

    setMachinePickerWoV2(null);
    setMachinePickerIdV2("");
    setMsg(result.message || "ID Mesin dipilih. WO diteruskan ke Quality.");
    await loadList();
    await loadWorkflowV2();
  }

  async function saveMachineMasterV2(e) {
    e.preventDefault();

    const payload = {
      machine_id: String(machineMasterV2.machine_id || "").trim(),
      machine_name: String(machineMasterV2.machine_name || "").trim(),
      line: String(machineMasterV2.line || "").trim(),
    };

    if (!payload.machine_id) {
      setMsg("ID Mesin wajib diisi.");
      return;
    }

    if (machineMasterV2.id) {
      await apiV2(`/machines/${machineMasterV2.id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });
      setMsg("Master mesin berhasil diperbarui.");
    } else {
      await apiV2("/machines", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      setMsg("Master mesin berhasil ditambahkan.");
    }

    setMachineMasterV2({ id: null, machine_id: "", machine_name: "", line: "" });
    await loadMachinesV2();
  }

  function selectMachineMasterV2(row) {
    setMachineMasterV2({
      id: row.id,
      machine_id: row.machine_id || "",
      machine_name: row.machine_name || "",
      line: row.line || "",
    });
  }

  function cancelMachineMasterEditV2() {
    setMachineMasterV2({ id: null, machine_id: "", machine_name: "", line: "" });
  }

  async function deleteMachineMasterV2() {
    if (!machineMasterV2.id) return;
    if (!window.confirm(`Nonaktifkan ID Mesin ${machineMasterV2.machine_id}?`)) return;

    await apiV2(`/machines/${machineMasterV2.id}`, { method: "DELETE" });
    setMachineMasterV2({ id: null, machine_id: "", machine_name: "", line: "" });
    await loadMachinesV2();
    setMsg("Master mesin dinonaktifkan.");
  }

  async function closeProduction(row) {
    if (!window.confirm(`Pastikan hasil perbaikan WO ${row.wo_no} sudah sesuai/OK. Lanjut Close Produksi?`)) return;
    await api(`/${row.id}/close-production`, {
      method: "POST",
      body: "{}",
    });

    await apiV2(`/production/${row.id}/final-close`, {
      method: "POST",
      body: "{}",
    });

    setMsg("WO sudah CLOSED oleh Produksi");
    await loadList();
    await loadWorkflowV2();
  }

  async function returnToEngineering(row) {
    const note = window.prompt(
      `Alasan WO ${row.wo_no} dikembalikan ke Engineering:`,
      row.produksi_return_note || ""
    );

    if (note === null) return;

    const cleanNote = String(note || "").trim();

    if (!cleanNote && !window.confirm("Catatan kosong. Tetap kembalikan ke Engineering?")) {
      return;
    }

    await api(`/${row.id}/return-engineering`, {
      method: "POST",
      body: JSON.stringify({ note: cleanNote }),
    });

    await apiV2(`/production/${row.id}/return-engineering`, {
      method: "POST",
      body: JSON.stringify({ note: cleanNote }),
    });

    setMsg(
      `WO ${row.wo_no} dikembalikan ke Engineering untuk perbaikan ulang`
    );
    await loadList();
  }

  async function approvePpicV2(row, priority, note = "") {
    await apiV2(`/ppic/${row.id}/approve`, {
      method: "POST",
      body: JSON.stringify({ priority, note }),
    });
    setMsg(`PPIC approve ${row.wo_no} dengan Prioritas ${priority}`);
    await loadList();
    await loadWorkflowV2();
    await loadUnreadV2();
  }

  async function returnPpicV2(row) {
    const note = window.prompt(
      `Alasan PPIC mengembalikan ${row.wo_no} ke Produksi:`,
      ""
    );
    if (note === null) return;
    if (!String(note || "").trim()) {
      setMsg("Alasan PPIC wajib diisi.");
      return;
    }
    await apiV2(`/ppic/${row.id}/return`, {
      method: "POST",
      body: JSON.stringify({ note }),
    });
    setMsg(`${row.wo_no} dikembalikan PPIC ke Produksi`);
    await loadList();
    await loadWorkflowV2();
  }

  async function approveQualityV2(row) {
    const note = window.prompt(
      `Catatan approval Quality ${row.wo_no} (opsional):`,
      ""
    );
    if (note === null) return;
    if (!window.confirm(`Approve Quality untuk ${row.wo_no}?`)) return;

    await apiV2(`/quality/${row.id}/approve`, {
      method: "POST",
      body: JSON.stringify({ note }),
    });
    setMsg(`Quality APPROVE ${row.wo_no}. WO siap review/close Produksi.`);
    await loadList();
    await loadWorkflowV2();
    await loadUnreadV2();
  }

  async function returnQualityV2(row) {
    const note = window.prompt(
      `Alasan Quality mengembalikan ${row.wo_no} ke Engineering:`,
      ""
    );
    if (note === null) return;
    if (!String(note || "").trim()) {
      setMsg("Alasan Quality wajib diisi.");
      return;
    }
    await apiV2(`/quality/${row.id}/return`, {
      method: "POST",
      body: JSON.stringify({ note }),
    });
    setMsg(`${row.wo_no} dikembalikan Quality ke Engineering untuk rework.`);
    await loadList();
    await loadWorkflowV2();
  }

  function openChatV2(row, defaultRole = "ENGINEERING") {
    setChatDefaultRoleV2(defaultRole);
    setChatWoV2(row);
  }

  function openFilesV2(row, allowUpload = false) {
    setFileUploadAllowedV2(!!allowUpload);
    setFileWoV2(row);
  }

  function openHistoryV2(row) {
    setHistoryWoV2(row);
  }

  function tabBadgeV2(key) {
    if (key === "create") {
      const waitingMachine = productionCloseRows.filter(
        (r) => String(r.workflow_stage || "").toUpperCase() === "WAITING_PRODUCTION_MACHINE"
      ).length;
      return waitingMachine + Number(unreadV2.PRODUCTION || 0);
    }
    if (key === "ppic") {
      return Number(ppicRowsV2.length || 0) + Number(unreadV2.PPIC || 0);
    }
    if (key === "engineering") return Number(unreadV2.ENGINEERING || 0);
    if (key === "quality") {
      return Number(qualityRowsV2.length || 0) + Number(unreadV2.QUALITY || 0);
    }
    if (key === "list") return Number(unreadV2.TOTAL || 0);
    if (key === "chat") return Number(unreadV2.TOTAL || 0);

    return 0;
  }

  async function deleteWO(row) {
    if (!window.confirm(`Hapus WO ${row.wo_no}?`)) return;
    await api(`/${row.id}`, { method: "DELETE" });
    setMsg("WO dihapus");
    await loadList();
  }

  async function saveMaster(e) {
    e.preventDefault();
    if (!master.value) return;

    const payload = {
      group_key: master.group_key,
      value: master.value,
      label: master.value,
    };

    if (master.id) {
      await api(`/options/${master.id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
      });
      setMsg("Master pilihan berhasil diupdate");
    } else {
      await api("/options", {
        method: "POST",
        body: JSON.stringify(payload),
      });
      setMsg("Master pilihan ditambahkan");
    }

    setMaster((m) => ({ ...m, id: null, value: "" }));
    await loadOptions();
  }

  function selectMasterOption(group, option) {
    setMaster({
      id: option.id,
      group_key: group,
      value: option.value || option.label || "",
    });
    setMsg(`Data master dipilih: ${option.value || option.label || ""}`);
  }

  function cancelMasterEdit() {
    setMaster((m) => ({
      ...m,
      id: null,
      value: "",
    }));
  }

  async function deleteSelectedMaster() {
    if (!master.id) return;

    if (!window.confirm(`Hapus data master "${master.value}"?`)) return;

    await api(`/options/${master.id}`, {
      method: "DELETE",
    });

    setMaster((m) => ({
      ...m,
      id: null,
      value: "",
    }));

    await loadOptions();
    setMsg("Master pilihan berhasil dihapus");
  }

  

  

  

  if (!tabs.length) {
    return (
    <div className="wo-page">
        <div className="wo-card">
          <h3>Tidak ada akses Aplikasi WO</h3>
          <p>Silakan minta admin memilih akses tab Aplikasi WO di menu Tambah User.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="wo-page">
      <style>{`
        .wo-page{padding:0 0 24px 0;background:transparent;min-height:auto;color:#0f172a;position:relative;width:100%;max-width:100%;overflow:visible}
        .wo-hero{border-radius:18px;background:linear-gradient(135deg,#0f766e,#2563eb);color:#fff;padding:18px 20px;box-shadow:0 12px 28px rgba(37,99,235,.22);margin-bottom:14px}
        .wo-hero h2{margin:0;font-weight:900}
        .wo-hero p{margin:5px 0 0;opacity:.9}
        .wo-tabs{display:flex;flex-wrap:wrap;gap:8px;margin-bottom:14px}
        .wo-tabs button{border:1px solid #e2e8f0;border-radius:12px;padding:10px 15px;font-weight:900;background:#fff;box-shadow:0 4px 12px rgba(15,23,42,.07);color:#334155;transition:.18s ease}
        .wo-tabs button:hover{transform:translateY(-1px);background:#eff6ff}.wo-tabs button.active{background:linear-gradient(135deg,#2563eb,#1d4ed8);color:#fff;border-color:#2563eb;box-shadow:0 8px 18px rgba(37,99,235,.24)}
        .wo-grid{display:grid;grid-template-columns:repeat(4,minmax(150px,1fr));gap:12px;margin-bottom:14px}
        .wo-card{background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:14px;box-shadow:0 4px 16px rgba(15,23,42,.05);margin-bottom:12px}
        .wo-kpi{font-size:28px;font-weight:900}
        .wo-kpi-label{font-weight:900;color:#64748b}
        .wo-form-grid{display:grid;grid-template-columns:repeat(3,minmax(220px,1fr));gap:12px}
        .wo-form-grid .full{grid-column:1/-1}
        .wo-field label{font-size:12px;font-weight:900;color:#334155;margin-bottom:5px;display:block}
        .wo-field input,.wo-field select,.wo-field textarea{width:100%;border:1px solid #cbd5e1;border-radius:10px;padding:9px 10px;background:#fff}
        .wo-field textarea{min-height:76px}
        .wo-actions{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}
        .wo-btn{border:0;border-radius:10px;padding:8px 12px;font-weight:900;cursor:pointer}
        .wo-primary{background:#2563eb;color:#fff}
        .wo-success{background:#16a34a;color:#fff}
        .wo-warning{background:#f59e0b;color:#111827}
        .wo-danger{background:#e11d48;color:#fff}
        .wo-muted{background:#e2e8f0;color:#334155}
        .wo-table-wrap{overflow:auto;border-radius:16px;border:1px solid #dbe5f0;background:#fff;box-shadow:0 8px 22px rgba(15,23,42,.055)}
        .wo-table{width:100%;border-collapse:separate;border-spacing:0;background:#fff;font-size:12px;min-width:1180px}.wo-table thead tr{background:#0f2347}
        .wo-table th{position:sticky;top:0;z-index:2;background:#0f2347!important;color:#fff;padding:10px 11px;white-space:nowrap;text-align:left;font-size:11px;letter-spacing:.2px;border-right:0!important;border-bottom:1px solid #dbe5f0}
        .wo-table td{border-bottom:1px solid #eef2f7;border-right:1px solid #f3f4f6;padding:9px 11px;vertical-align:top;white-space:nowrap;color:#0f172a}
        .wo-table tbody tr:nth-child(even) td{background:#fbfdff}.wo-table tr:hover td{background:#eef6ff!important}.wo-table th:first-child{border-top-left-radius:12px}.wo-table th:last-child{border-top-right-radius:12px;border-right:0}.wo-table td:last-child{border-right:0}
        .wo-badge{border-radius:999px;padding:4px 8px;font-weight:900;font-size:11px;background:#e2e8f0}
        .wo-open{background:#fee2e2;color:#991b1b}
        .wo-progress{background:#fef3c7;color:#92400e}
        .wo-resolved{background:#dbeafe;color:#1d4ed8}
        .wo-closed{background:#dcfce7;color:#166534}
        .wo-msg{margin:10px 0;padding:10px 12px;border-radius:12px;background:#e0f2fe;color:#075985;font-weight:800}
        .wo-parts{max-height:220px;overflow:auto;border:1px solid #e2e8f0;border-radius:12px;margin-top:8px}
        .wo-part-item{padding:9px 10px;border-bottom:1px solid #e2e8f0;cursor:pointer}
        .wo-part-item:hover{background:#eff6ff}
        .wo-flow{display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin:10px 0}
        .wo-flow div{background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;padding:10px;font-size:12px}
        .wo-flow b{display:block;color:#0f172a}
        .wo-chart{display:grid;grid-template-columns:repeat(4,1fr);gap:12px;align-items:end;height:230px;padding:20px 8px 6px}
        .wo-chart-item{display:flex;flex-direction:column;align-items:center;justify-content:flex-end;height:100%}
        .wo-chart-bar{width:60%;min-height:8px;border-radius:10px 10px 0 0;background:#2563eb}
        .wo-chart-label{text-align:center;font-weight:900;margin-top:8px}
        .wo-chart-num{font-size:22px;font-weight:900;margin-top:4px}
        .wo-open-bar{background:#ef4444}.wo-progress-bar{background:#f59e0b}.wo-resolved-bar{background:#3b82f6}.wo-closed-bar{background:#22c55e}
        
        .wo-engineering-panel > .wo-card{
          display:inline-block;
          width:31.7%;
          vertical-align:top;
          margin-right:1.2%;
          min-height:180px;
          padding:12px;
        }
        .wo-engineering-panel > .wo-card h4{
          margin:0 0 8px;
          font-size:16px;
        }
        .wo-engineering-panel > .wo-card textarea{
          min-height:56px!important;
        }
        .wo-engineering-panel > .wo-card .wo-actions{
          margin-top:6px;
        }

        
        .wo-decision-grid{
          display:grid;
          grid-template-columns:repeat(3,minmax(180px,1fr));
          gap:12px;
          margin-top:12px;
        }
        .wo-decision-card{
          border:1px solid #cbd5e1;
          background:#fff;
          border-radius:14px;
          padding:12px;
          min-height:150px;
          box-shadow:0 3px 12px rgba(15,23,42,.04);
        }
        .wo-decision-card.selected{
          border-color:#93c5fd;
          background:#f8fbff;
        }
        .wo-decision-card h4{
          margin:0 0 8px;
          font-size:16px;
        }
        .wo-decision-card textarea{
          min-height:54px!important;
        }
        .wo-decision-warning{
          margin-top:10px;
          padding:8px 10px;
          border-radius:10px;
          background:#fee2e2;
          color:#991b1b;
          font-weight:900;
          font-size:12px;
        }

        
        @keyframes woFadeUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:translateY(0)}}
        @keyframes woPulseSoft{0%,100%{box-shadow:0 0 0 0 rgba(37,99,235,.22)}50%{box-shadow:0 0 0 10px rgba(37,99,235,0)}}
        @keyframes woBarGrow{from{width:0}to{width:var(--target-width,100%)}}
        .wo-dash{animation:woFadeUp .45s ease both}
        .wo-dash-grid{display:grid;grid-template-columns:repeat(4,minmax(160px,1fr));gap:14px;margin-bottom:14px}
        .wo-dash-kpi{
          position:relative;
          overflow:hidden;
          display:flex;
          align-items:center;
          gap:13px;
          padding:18px;
          border-radius:18px;
          border:1px solid rgba(148,163,184,.35);
          background:linear-gradient(135deg,#ffffff,#f8fbff);
          box-shadow:0 10px 28px rgba(15,23,42,.08);
          animation:woFadeUp .45s ease both;
        }
        .wo-dash-kpi:before{
          content:"";
          position:absolute;
          right:-28px;
          top:-28px;
          width:95px;
          height:95px;
          border-radius:50%;
          opacity:.13;
          background:#2563eb;
        }
        .wo-dash-kpi.green:before{background:#22c55e}
        .wo-dash-kpi.orange:before{background:#f59e0b}
        .wo-dash-kpi.purple:before{background:#8b5cf6}
        .wo-dash-kpi-icon{
          width:54px;
          height:54px;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius:16px;
          background:#eff6ff;
          font-size:26px;
          animation:woPulseSoft 2.4s infinite;
        }
        .wo-dash-kpi-value{font-size:30px;font-weight:900;line-height:1}
        .wo-dash-kpi-title{font-weight:900;color:#0f172a;margin-top:4px}
        .wo-dash-kpi-hint{font-size:12px;font-weight:800;color:#64748b;margin-top:3px}
        .wo-dash-main{display:grid;grid-template-columns:1.1fr .9fr;gap:14px;margin-bottom:14px}
        .wo-dash-main-3{grid-template-columns:1fr 1fr 1fr}
        .wo-dash-card{
          background:#fff;
          border:1px solid #e2e8f0;
          border-radius:18px;
          padding:16px;
          box-shadow:0 10px 28px rgba(15,23,42,.07);
          animation:woFadeUp .5s ease both;
        }
        .wo-card-title{display:flex;justify-content:space-between;gap:12px;align-items:flex-start;margin-bottom:12px}
        .wo-card-title h3{margin:0;font-size:20px;font-weight:900;color:#0f172a}
        .wo-card-title p{margin:4px 0 0;color:#64748b;font-weight:800}
        .wo-live-pill{
          display:inline-flex;
          align-items:center;
          padding:6px 10px;
          border-radius:999px;
          color:#065f46;
          background:#d1fae5;
          font-size:12px;
          font-weight:900;
        }
        .wo-donut-wrap{display:grid;grid-template-columns:240px 1fr;gap:18px;align-items:center}
        .wo-donut{
          width:220px;
          height:220px;
          border-radius:50%;
          display:flex;
          align-items:center;
          justify-content:center;
          box-shadow:inset 0 0 0 1px rgba(15,23,42,.08),0 14px 30px rgba(15,23,42,.10);
          position:relative;
        }
        .wo-donut:after{
          content:"";
          position:absolute;
          inset:28px;
          background:#fff;
          border-radius:50%;
          box-shadow:inset 0 0 0 1px #e2e8f0;
        }
        .wo-donut-center{position:relative;z-index:1;text-align:center}
        .wo-donut-center b{display:block;font-size:34px;font-weight:900}
        .wo-donut-center span{font-weight:900;color:#64748b}
        .wo-donut-legend{display:grid;gap:9px}
        .wo-legend-row{
          display:grid;
          grid-template-columns:16px 1fr 42px 42px;
          align-items:center;
          gap:8px;
          padding:9px 10px;
          border-radius:12px;
          background:#f8fafc;
          font-weight:900;
        }
        .wo-legend-dot{width:11px;height:11px;border-radius:999px}
        .wo-legend-row small{color:#64748b;text-align:right}
        .wo-bar-list{display:grid;gap:12px}
        .wo-bar-row{font-weight:900}
        .wo-bar-top{display:flex;justify-content:space-between;gap:10px;margin-bottom:6px}
        .wo-bar-track{height:12px;background:#e2e8f0;border-radius:999px;overflow:hidden}
        .wo-bar-fill{
          height:100%;
          border-radius:999px;
          background:linear-gradient(90deg,#0f766e,#2563eb);
          transition:width .7s ease;
        }
        .wo-bar-row small{color:#64748b}
        .wo-aging-box{display:grid;grid-template-columns:1fr 1fr;gap:10px}
        .wo-aging-box div{
          border-radius:16px;
          padding:14px;
          background:linear-gradient(135deg,#eff6ff,#f8fafc);
          border:1px solid #dbeafe;
        }
        .wo-aging-box b{display:block;font-size:30px;font-weight:900}
        .wo-aging-box span{font-weight:900;color:#64748b}
        .wo-status-note{
          margin-top:12px;
          padding:10px;
          border-radius:12px;
          background:#ecfeff;
          color:#155e75;
          font-weight:900;
        }
        .wo-activity-list{display:grid;gap:8px}
        .wo-activity-item{
          display:grid;
          grid-template-columns:42px 1fr auto;
          align-items:center;
          gap:10px;
          padding:10px;
          border-radius:14px;
          background:#f8fafc;
          border:1px solid #e2e8f0;
        }
        .wo-activity-icon{
          width:38px;
          height:38px;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius:12px;
          background:#dbeafe;
        }
        .wo-activity-item b{display:block;font-weight:900}
        .wo-activity-item span{font-size:12px;color:#475569;font-weight:800}
        .wo-empty-state{
          padding:18px;
          border-radius:14px;
          background:#f8fafc;
          color:#64748b;
          font-weight:900;
          text-align:center;
          border:1px dashed #cbd5e1;
        }

        
        .wo-table td b{font-weight:900;color:#0f172a}
        .wo-table .wo-actions{gap:6px}
        .wo-table .wo-btn{padding:7px 10px;border-radius:9px;font-size:11px;box-shadow:0 2px 8px rgba(15,23,42,.08)}
        .wo-table-wrap::-webkit-scrollbar{height:10px;width:10px}
        .wo-table-wrap::-webkit-scrollbar-track{background:#f1f5f9;border-radius:999px}
        .wo-table-wrap::-webkit-scrollbar-thumb{background:#94a3b8;border-radius:999px}
        .wo-table-wrap::-webkit-scrollbar-thumb:hover{background:#64748b}

        @media(max-width:1100px){.wo-grid,.wo-form-grid,.wo-flow,.wo-chart,.wo-decision-grid,.wo-dash-grid,.wo-dash-main,.wo-dash-main-3,.wo-donut-wrap{grid-template-columns:1fr}.wo-engineering-panel > .wo-card{display:block;width:100%;margin-right:0}}
        @media print{.wo-tabs,.wo-actions,.no-print{display:none!important}.wo-page{background:#fff;padding:0}.wo-card{box-shadow:none;border:1px solid #ddd}.wo-hero{background:#fff;color:#000;box-shadow:none;border:1px solid #ddd}}
      `}</style>

      <div className="wo-hero">
        {/* SIP_WO_PERMISSION_PRODUKSI_INFO_R18 */}
        <h2>🛠️ Aplikasi WO Engineering</h2>
        <p>Work Order produksi ke engineering, terhubung dengan master part OEE.</p>
      </div>

      <div className="wo-tabs no-print">
        {tabs.map((x) => (
          <button key={x.key} className={tab === x.key ? "active" : ""} onClick={() => setTab(x.key)}>
            {x.label}
            {tabBadgeV2(x.key) > 0 && (
              <span className="wo-tab-badge-v2">
                {tabBadgeV2(x.key)}
              </span>
            )}
          </button>
        ))}
      </div>

      {msg && <div className="wo-msg">{msg}</div>}

      {tab === "dashboard" && (
        <DashboardOverviewV2 list={list} />
      )}

      {tab === "list" && (
        <>
          <AdvancedFilterBoxV2 filters={filters} setFilters={setFilters} loadList={loadList} options={{ urgencyOptions, kategoriOptions, areaOptions, prosesOptions }} />
          <RecapTable title="List WO - Rekap Semua Data" list={list} showAction={false} />
        </>
      )}

      {tab === "create" && (
        <>
          <CreateForm
            form={form}
            setForm={setForm}
            saveWO={saveWO}
            partQ={partQ}
            setPartQ={setPartQ}
            loadParts={loadParts}
            parts={parts}
            selectPart={selectPart}
            urgencyOptions={urgencyOptions}
            kategoriOptions={kategoriOptions}
            areaOptions={areaOptions}
            prosesOptions={prosesOptions}
            editingProduction={editingProduction}
            cancelProductionEdit={cancelProductionEdit}
          />

          <WorkflowTabFilterV3
            title="Filter Input Produksi"
            tabKey="create"
            filter={workflowTabFiltersV3.create}
            onChange={updateWorkflowTabFilterV3}
            onReset={resetWorkflowTabFilterV3}
            total={productionCloseRows.length}
            shown={productionCloseRowsFilteredV3.length}
            options={{ urgencyOptions, kategoriOptions, areaOptions, prosesOptions }}
          />

          <div className="wo-card">
            <h3>WO Produksi: Edit / Pilih Mesin / Review Hasil</h3>
            <RecapTable
              title=""
              list={productionCloseRowsFilteredV3}
              showAction={true}
              actionMode="production"
              closeProduction={closeProduction}
              returnToEngineering={returnToEngineering}
              openProductionEdit={openProductionEdit}
              openMachinePicker={openMachinePickerV2}
              canAssignMachine={hasPerm("engineering.wo.production.assign")}
              openChat={null}
            />
          </div>
        </>
      )}

      {tab === "ppic" && (
        <>
          <WorkflowTabFilterV3
            title="Filter PPIC"
            tabKey="ppic"
            filter={workflowTabFiltersV3.ppic}
            onChange={updateWorkflowTabFilterV3}
            onReset={resetWorkflowTabFilterV3}
            total={ppicRowsV2.length}
            shown={ppicRowsFilteredV3.length}
            options={{ urgencyOptions, kategoriOptions, areaOptions, prosesOptions }}
          />
          <PpicApprovalPanelV2
            rows={ppicRowsFilteredV3}
            approve={approvePpicV2}
            reject={returnPpicV2}
            openChat={null}
            openHistory={openHistoryV2}
            canApprove={hasPerm("engineering.wo.ppic.approve")}
          />
        </>
      )}

      {tab === "engineering" && (
        <>
          <div className="wo-card">
            <h3>Engineering</h3>
            <p>List di bawah ini adalah WO yang masih OPEN atau PROGRESS. Proses Engineering dilakukan dari tab ini.</p>
          </div>

          <WorkflowTabFilterV3
            title="Filter Engineering"
            tabKey="engineering"
            filter={workflowTabFiltersV3.engineering}
            onChange={updateWorkflowTabFilterV3}
            onReset={resetWorkflowTabFilterV3}
            total={engineeringRows.length}
            shown={engineeringRowsFilteredV3.length}
            options={{ urgencyOptions, kategoriOptions, areaOptions, prosesOptions }}
          />

          <RecapTable
            title="List WO untuk Engineering"
            list={engineeringRowsFilteredV3}
            showAction={true}
            actionMode="engineering"
            openEngineering={openEngineering}
            openChat={null}
            deleteWO={hasPerm("engineering.wo.delete") ? deleteWO : null}
          />

          {selected && (
            <>
              <EngineeringPanel
              selected={selected}
              engForm={engForm}
              setEngForm={setEngForm}
              analisaOptions={analisaOptions}
              saveEngineeringProgress={saveEngineeringProgress}
              closeEngineering={closeEngineering}
            />
            <div className="wo-card wo-workflow-tools-v2">
              <b>Dokumentasi & Komunikasi WO {selected.wo_no}</b>
              <div className="wo-actions">
                <button
                  className="wo-btn wo-primary"
                  type="button"
                  onClick={() =>
                    openFilesV2(
                      selected,
                      hasPerm("engineering.wo.engineering.photo") ||
                        hasPerm("engineering.wo.engineering")
                    )
                  }
                >
                  📷 Foto / File
                </button>

                

                <button
                  className="wo-btn wo-muted"
                  type="button"
                  onClick={() => openHistoryV2(selected)}
                >
                  📜 History
                </button>
              </div>
            </div>
            </>
          )}
        </>
      )}

      {tab === "quality" && (
        <>
          <WorkflowTabFilterV3
            title="Filter Quality"
            tabKey="quality"
            filter={workflowTabFiltersV3.quality}
            onChange={updateWorkflowTabFilterV3}
            onReset={resetWorkflowTabFilterV3}
            total={qualityRowsV2.length}
            shown={qualityRowsFilteredV3.length}
            options={{ urgencyOptions, kategoriOptions, areaOptions, prosesOptions }}
          />
          <QualityApprovalPanelV2
            rows={qualityRowsFilteredV3}
            approve={approveQualityV2}
            reject={returnQualityV2}
            openFiles={(r) => openFilesV2(r, false)}
            openChat={null}
            openHistory={openHistoryV2}
            canApprove={hasPerm("engineering.wo.quality.approve")}
          />
        </>
      )}

      {/* SIP_WO_FLOATING_CHAT_V4 */}
      {hasPerm("engineering.wo.chat") && (
        <WoFloatingChatV4
          list={list}
          unread={unreadV2}
          onUnreadRefresh={loadUnreadV2}
        />
      )}
      {tab === "admin" && (
        <div className="wo-card wo-master-admin-final-card">
          <h3>Master Pilihan Admin</h3>
          <form onSubmit={saveMaster} className="wo-form-grid wo-master-admin-form wo-master-admin-final-form">
            <div className="wo-field">
              <label>Group</label>
              <select value={master.group_key} onChange={(e) => setMaster({ ...master, group_key: e.target.value })}>
                <option value="urgency">Prioritas</option>
                <option value="kategori">Dampak</option>
                <option value="area_dies">Area Dies</option>
                <option value="proses">Proses</option>
                <option value="analisa_penyebab">Analisa Penyebab</option>
              </select>
            </div>
            <div className="wo-field">
              <label>Nama Pilihan Baru</label>
              <input value={master.value} onChange={(e) => setMaster({ ...master, value: e.target.value })} />
            </div>
            <div className="wo-field">
              <label>&nbsp;</label>
              {master.id ? (
                <div className="wo-master-admin-edit-panel">
                  <button className="wo-btn wo-primary" type="submit">
                    Simpan Perubahan
                  </button>
                  <button className="wo-btn wo-danger" type="button" onClick={deleteSelectedMaster}>
                    Hapus Data
                  </button>
                  <button className="wo-btn wo-muted" type="button" onClick={cancelMasterEdit}>
                    Batal
                  </button>
                </div>
              ) : (
                <button className="wo-btn wo-success" type="submit">
                  Tambah Master
                </button>
              )}
            </div>
          </form>

          <div className="wo-table-wrap" style={{ marginTop: 14 }}>
            <table className="wo-table wo-master-admin-table wo-master-admin-final-table">
              <thead><tr><th>Group</th><th>Value</th></tr></thead>
              <tbody>
                {Object.entries(options).flatMap(([group, arr]) =>
                  arr.map((x) => (
                    <tr
                      key={`${group}-${x.id}`}
                      onClick={() => selectMasterOption(group, x)}
                      className={master.id === x.id ? "wo-master-row-selected" : ""}
                      title="Klik untuk edit / hapus data ini"
                    >
                      <td>{group}</td>
                      <td>{x.value}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <hr style={{ margin: "24px 0", border: 0, borderTop: "1px solid #e2e8f0" }} />
          <h3>Master Data Mesin</h3>
          <p>Daftar ID Mesin yang dapat dipilih Produksi setelah Engineering CLOSE.</p>

          <form onSubmit={saveMachineMasterV2} className="wo-form-grid wo-master-admin-form wo-master-admin-final-form">
            <div className="wo-field">
              <label>ID Mesin</label>
              <input
                value={machineMasterV2.machine_id}
                onChange={(e) => setMachineMasterV2({ ...machineMasterV2, machine_id: e.target.value })}
                placeholder="Contoh: MC-001"
              />
            </div>
            <div className="wo-field">
              <label>Nama Mesin</label>
              <input
                value={machineMasterV2.machine_name}
                onChange={(e) => setMachineMasterV2({ ...machineMasterV2, machine_name: e.target.value })}
                placeholder="Nama mesin"
              />
            </div>
            <div className="wo-field">
              <label>Line</label>
              <input
                value={machineMasterV2.line}
                onChange={(e) => setMachineMasterV2({ ...machineMasterV2, line: e.target.value })}
                placeholder="Line / area (opsional)"
              />
            </div>
            <div className="wo-field">
              <label>&nbsp;</label>
              <div className="wo-actions">
                <button className="wo-btn wo-success" type="submit">
                  {machineMasterV2.id ? "Simpan Mesin" : "Tambah Mesin"}
                </button>
                {machineMasterV2.id && (
                  <>
                    <button className="wo-btn wo-danger" type="button" onClick={deleteMachineMasterV2}>Nonaktifkan</button>
                    <button className="wo-btn wo-muted" type="button" onClick={cancelMachineMasterEditV2}>Batal</button>
                  </>
                )}
              </div>
            </div>
          </form>

          <div className="wo-table-wrap" style={{ marginTop: 14 }}>
            <table className="wo-table wo-master-admin-table wo-master-admin-final-table">
              <thead><tr><th>ID Mesin</th><th>Nama Mesin</th><th>Line</th></tr></thead>
              <tbody>
                {machineRowsV2.map((m) => (
                  <tr
                    key={m.id}
                    onClick={() => selectMachineMasterV2(m)}
                    className={machineMasterV2.id === m.id ? "wo-master-row-selected" : ""}
                    title="Klik untuk edit / nonaktifkan mesin"
                  >
                    <td><b>{m.machine_id}</b></td>
                    <td>{m.machine_name || "-"}</td>
                    <td>{m.line || "-"}</td>
                  </tr>
                ))}
                {!machineRowsV2.length && (
                  <tr><td colSpan="3" style={{ textAlign: "center", padding: 18 }}>Belum ada master mesin.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {machinePickerWoV2 && (
        <MachinePickerModalV2
          wo={machinePickerWoV2}
          machines={machineRowsV2}
          selectedId={machinePickerIdV2}
          setSelectedId={setMachinePickerIdV2}
          onOk={confirmMachinePickerV2}
          onCancel={() => {
            setMachinePickerWoV2(null);
            setMachinePickerIdV2("");
          }}
        />
      )}

      {chatWoV2 && (
        <WoChatModalV2
          wo={chatWoV2}
          defaultRole={chatDefaultRoleV2}
          onClose={() => {
            setChatWoV2(null);
            loadUnreadV2();
          }}
        />
      )}

      {fileWoV2 && (
        <WoFilesModalV2
          wo={fileWoV2}
          allowUpload={fileUploadAllowedV2}
          onClose={() => {
            setFileWoV2(null);
            loadList();
            loadWorkflowV2();
          }}
        />
      )}

      {historyWoV2 && (
        <WoHistoryModalV2
          wo={historyWoV2}
          onClose={() => setHistoryWoV2(null)}
        />
      )}

      {tab === "print" && (
        <>
          <AdvancedFilterBoxV2 filters={filters} setFilters={setFilters} loadList={loadList} options={{ urgencyOptions, kategoriOptions, areaOptions, prosesOptions }} />
          <div className="wo-actions no-print">
            <button className="wo-btn wo-muted" onClick={() => window.print()}>Print Laporan</button>
          </div>
          <RecapTable title="Laporan WO Engineering" list={list} showAction={false} />
        </>
      )}
    </div>
  );
}


function pct(value, total) {
  if (!total) return 0;
  return Math.round((Number(value || 0) / Number(total || 1)) * 100);
}

function safeDate(value) {
  if (!value) return null;
  const raw = sipWoLocalDateV11(value);
  const d = new Date(`${raw}T00:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}

function diffDaysFromNow(value) {
  const d = safeDate(value);
  if (!d) return 0;
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.max(0, Math.floor((start - d) / 86400000));
}

function groupCount(rows, field, fallback = "-") {
  const map = {};
  rows.forEach((r) => {
    const key = r?.[field] || fallback;
    map[key] = (map[key] || 0) + 1;
  });
  return Object.entries(map)
    .map(([label, value]) => ({ label, value }))
    .sort((a, b) => b.value - a.value);
}

function DashboardOverview({ counts, list, loadList }) {
  const total = counts.TOTAL || 0;
  const active = (counts.OPEN || 0) + (counts.PROGRESS || 0);
  const finish = (counts.RESOLVED || 0) + (counts.CLOSED || 0);
  const closeRate = pct(counts.CLOSED || 0, total);

  const urgencyData = groupCount(list, "urgency").slice(0, 5);
  const kategoriData = groupCount(list, "kategori").slice(0, 5);
  const lineData = groupCount(list, "line").slice(0, 6);

  const openAging = list
    .filter((r) => ["OPEN", "PROGRESS"].includes(String(r.status_wo || "").toUpperCase()))
    .map((r) => diffDaysFromNow(r.tanggal_masuk));

  const maxAging = openAging.length ? Math.max(...openAging) : 0;
  const avgAging = openAging.length
    ? Math.round(openAging.reduce((a, b) => a + b, 0) / openAging.length)
    : 0;

  const recent = [...list].slice(0, 6);

  const pOpen = pct(counts.OPEN || 0, total);
  const pProgress = pct(counts.PROGRESS || 0, total);
  const pResolved = pct(counts.RESOLVED || 0, total);
  const pClosed = pct(counts.CLOSED || 0, total);

  const donutGradient = total
    ? `conic-gradient(#ef4444 0 ${pOpen}%, #f59e0b ${pOpen}% ${pOpen + pProgress}%, #3b82f6 ${pOpen + pProgress}% ${pOpen + pProgress + pResolved}%, #22c55e ${pOpen + pProgress + pResolved}% 100%)`
    : "conic-gradient(#e5e7eb 0 100%)";

  return (
    <div className="wo-dash">
      <div className="wo-dash-grid">
        <DashKpi title="Total WO Masuk" value={total} icon="📥" hint="Semua WO berdasarkan data tampil" tone="blue" />
        <DashKpi title="WO Aktif" value={active} icon="⚙️" hint="OPEN + PROGRESS" tone="orange" />
        <DashKpi title="Selesai Engineering" value={finish} icon="🛠️" hint="RESOLVED + CLOSED" tone="purple" />
        <DashKpi title="Close Rate" value={`${closeRate}%`} icon="✅" hint="CLOSED dibanding total WO" tone="green" />
      </div>

      <div className="wo-dash-main">
        <div className="wo-dash-card wo-donut-card">
          <div className="wo-card-title">
            <div>
              <h3>Status WO</h3>
              <p>Komposisi status keseluruhan</p>
            </div>
            <span className="wo-live-pill">LIVE</span>
          </div>

          <div className="wo-donut-wrap">
            <div className="wo-donut" style={{ background: donutGradient }}>
              <div className="wo-donut-center">
                <b>{total}</b>
                <span>Total WO</span>
              </div>
            </div>

            <div className="wo-donut-legend">
              <Legend color="#ef4444" label="OPEN" value={counts.OPEN} pct={pOpen} />
              <Legend color="#f59e0b" label="PROGRESS" value={counts.PROGRESS} pct={pProgress} />
              <Legend color="#3b82f6" label="RESOLVED" value={counts.RESOLVED} pct={pResolved} />
              <Legend color="#22c55e" label="CLOSED" value={counts.CLOSED} pct={pClosed} />
            </div>
          </div>
        </div>

        <div className="wo-dash-card">
          <div className="wo-card-title">
            <div>
              <h3>Prioritas WO</h3>
              <p>Prioritas pekerjaan yang masuk</p>
            </div>
          </div>
          <BarList data={urgencyData} total={total} emptyText="Belum ada data prioritas" />
        </div>
      </div>

      <div className="wo-dash-main wo-dash-main-3">
        <div className="wo-dash-card">
          <div className="wo-card-title">
            <div>
              <h3>Dampak Problem</h3>
              <p>Perbandingan BO dan Man Power</p>
            </div>
          </div>
          <BarList data={kategoriData} total={total} emptyText="Belum ada data kategori" />
        </div>

        <div className="wo-dash-card">
          <div className="wo-card-title">
            <div>
              <h3>Top Line / Area</h3>
              <p>Line dengan WO terbanyak</p>
            </div>
          </div>
          <BarList data={lineData} total={total} emptyText="Belum ada data line" />
        </div>

        <div className="wo-dash-card">
          <div className="wo-card-title">
            <div>
              <h3>Aging WO Aktif</h3>
              <p>Lama WO OPEN/PROGRESS</p>
            </div>
          </div>

          <div className="wo-aging-box">
            <div>
              <b>{maxAging}</b>
              <span>Hari Terlama</span>
            </div>
            <div>
              <b>{avgAging}</b>
              <span>Rata-rata Hari</span>
            </div>
          </div>

          <div className="wo-status-note">
            {active > 0
              ? `${active} WO masih perlu dimonitor sampai closed.`
              : "Tidak ada WO aktif. Semua pekerjaan aman."}
          </div>
        </div>
      </div>

      <div className="wo-dash-card">
        <div className="wo-card-title">
          <div>
            <h3>Aktivitas WO Terbaru</h3>
            <p>Monitoring cepat data terakhir</p>
          </div>
          <button className="wo-btn wo-primary no-print" onClick={() => loadList()}>
            Refresh Dashboard
          </button>
        </div>

        <div className="wo-activity-list">
          {recent.map((r) => (
            <div className="wo-activity-item" key={r.id}>
              <div className="wo-activity-icon">🛠️</div>
              <div>
                <b>{r.wo_no}</b>
                <span>{r.nama_part || "-"} | {r.line || "-"} | {r.urgency || "-"}</span>
              </div>
              <span className={statusClass(r.status_wo)}>{r.status_wo}</span>
            </div>
          ))}
          {!recent.length && <div className="wo-empty-state">Belum ada aktivitas WO.</div>}
        </div>
      </div>
    </div>
  );
}

function DashKpi({ title, value, icon, hint, tone }) {
  return (
    <div className={`wo-dash-kpi ${tone || ""}`}>
      <div className="wo-dash-kpi-icon">{icon}</div>
      <div>
        <div className="wo-dash-kpi-value">{value}</div>
        <div className="wo-dash-kpi-title">{title}</div>
        <div className="wo-dash-kpi-hint">{hint}</div>
      </div>
    </div>
  );
}

function Legend({ color, label, value, pct }) {
  return (
    <div className="wo-legend-row">
      <span className="wo-legend-dot" style={{ background: color }} />
      <span>{label}</span>
      <b>{value || 0}</b>
      <small>{pct || 0}%</small>
    </div>
  );
}

function BarList({ data, total, emptyText }) {
  if (!data.length) return <div className="wo-empty-state">{emptyText}</div>;

  return (
    <div className="wo-bar-list">
      {data.map((x) => {
        const width = Math.max(5, pct(x.value, total));
        return (
          <div className="wo-bar-row" key={x.label}>
            <div className="wo-bar-top">
              <span>{x.label}</span>
              <b>{x.value}</b>
            </div>
            <div className="wo-bar-track">
              <div className="wo-bar-fill" style={{ width: `${width}%` }} />
            </div>
            <small>{pct(x.value, total)}%</small>
          </div>
        );
      })}
    </div>
  );
}


function Kpi({ title, value }) {
  return (
    <div className="wo-card">
      <div className="wo-kpi">{value}</div>
      <div className="wo-kpi-label">{title}</div>
    </div>
  );
}

function ChartBar({ label, value, total, cls }) {
  const h = total ? Math.max(8, Math.round((Number(value || 0) / total) * 180)) : 8;
  const pct = total ? Math.round((Number(value || 0) / total) * 100) : 0;
  return (
    <div className="wo-chart-item">
      <div className={`wo-chart-bar ${cls}`} style={{ height: h }} />
      <div className="wo-chart-label">{label}</div>
      <div className="wo-chart-num">{value}</div>
      <small>{pct}%</small>
    </div>
  );
}

function FilterBox({ filters, setFilters, loadList, options }) {
  return (
    <div className="wo-card no-print">
      <div className="wo-form-grid">
        <div className="wo-field">
          <label>Status</label>
          <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
            <option value="">Semua</option>
            {["OPEN", "PROGRESS", "RESOLVED", "CLOSED"].map((x) => <option key={x}>{x}</option>)}
          </select>
        </div>
        <div className="wo-field">
          <label>Prioritas</label>
          <select value={filters.urgency} onChange={(e) => setFilters({ ...filters, urgency: e.target.value })}>
            <option value="">Semua</option>
            {options.urgencyOptions.map((x) => <option key={x}>{x}</option>)}
          </select>
        </div>
        <div className="wo-field">
          <label>Dampak</label>
          <select value={filters.kategori} onChange={(e) => setFilters({ ...filters, kategori: e.target.value })}>
            <option value="">Semua</option>
            {options.kategoriOptions.map((x) => <option key={x}>{x}</option>)}
          </select>
        </div>
        <div className="wo-field"><label>Dari Tanggal</label><input type="date" value={filters.date_from} onChange={(e) => setFilters({ ...filters, date_from: e.target.value })} /></div>
        <div className="wo-field"><label>Sampai Tanggal</label><input type="date" value={filters.date_to} onChange={(e) => setFilters({ ...filters, date_to: e.target.value })} /></div>
        <div className="wo-field"><label>Cari</label><input value={filters.q} onChange={(e) => setFilters({ ...filters, q: e.target.value })} placeholder="WO / part / line / masalah" /></div>
      </div>
      <div className="wo-actions">
        <button className="wo-btn wo-primary" onClick={() => loadList()}>Cari / Refresh</button>
      </div>
    </div>
  );
}

function CreateForm(props) {
  const {
    form, setForm, saveWO, partQ, setPartQ, loadParts, parts, selectPart,
    urgencyOptions, kategoriOptions, areaOptions, prosesOptions,
    editingProduction, cancelProductionEdit
  } = props;

  return (
    <div className="wo-card">
      <h3>{editingProduction ? `Edit WO Produksi - ${editingProduction.wo_no}` : "Input WO Produksi"}</h3>
      <form onSubmit={saveWO}>
        <div className="wo-form-grid">
          <div className="wo-field">
            <label>Prioritas</label>
            <input
              disabled
              value="Ditentukan oleh PPIC setelah WO dibuat"
              title="Produksi tidak menentukan Prioritas"
            />
          </div>
          <div className="wo-field"><label>Dampak</label><select value={form.kategori} onChange={(e) => setForm({ ...form, kategori: e.target.value })}>{kategoriOptions.map((x) => <option key={x}>{x}</option>)}</select></div>
          <div className="wo-field"><label>Area Dies</label><select value={form.area_dies} onChange={(e) => setForm({ ...form, area_dies: e.target.value })}>{areaOptions.map((x) => <option key={x}>{x}</option>)}</select></div>

          <div className="wo-field full">
            <label>Cari Nama Part dari Master Data OEE</label>
            <div>
              <input
                value={partQ}
                onChange={(e) => setPartQ(e.target.value)}
                placeholder="Ketik nama part / kode part / line, data otomatis muncul"
              />
              <small style={{ display: "block", marginTop: 5, color: "#64748b", fontWeight: 800 }}>
                Data part otomatis muncul saat diketik.
              </small>
            </div>
            <div className="wo-parts">
              {parts.map((p, idx) => (
                <div className="wo-part-item" key={`${p.kode_part}-${idx}`} onClick={() => selectPart(p)}>
                  <b>{p.nama_part}</b><br />
                  Kode: {p.kode_part || "-"} | Line: {p.line || "-"} | Proses: {p.proses || "-"}
                </div>
              ))}
            </div>
          </div>

          <div className="wo-field"><label>Nama Part</label><input value={form.nama_part} onChange={(e) => setForm({ ...form, nama_part: e.target.value })} /></div>
          <div className="wo-field"><label>Line</label><input value={form.line} onChange={(e) => setForm({ ...form, line: e.target.value })} /></div>
          <div className="wo-field"><label>Kode Part</label><input value={form.kode_part} onChange={(e) => setForm({ ...form, kode_part: e.target.value })} /></div>
          <div className="wo-field"><label>Proses</label><select value={form.proses} onChange={(e) => setForm({ ...form, proses: e.target.value })}>{prosesOptions.map((x) => <option key={x}>{x}</option>)}</select></div>
          <div className="wo-field"><label>Tanggal Masuk</label><input disabled value="Auto saat WO dibuat" /></div>
          <div className="wo-field"><label>Jam Masuk</label><input disabled value="Auto saat WO dibuat" /></div>
          <div className="wo-field full"><label>Uraian Masalah</label><textarea value={form.uraian_masalah} onChange={(e) => setForm({ ...form, uraian_masalah: e.target.value })} /></div>
        </div>
        <div className="wo-actions">
          <button className="wo-btn wo-success">{editingProduction ? "Update WO Produksi" : "Simpan WO Produksi"}</button>
          {editingProduction && <button type="button" className="wo-btn wo-muted" onClick={cancelProductionEdit}>Batal Edit</button>}
        </div>
      </form>
    </div>
  );
}


function EngineeringPanel(props) {
  const {
    selected, engForm, setEngForm, analisaOptions, saveEngineeringProgress, closeEngineering
  } = props;

  const showDecisionCards = String(engForm.tindakan_perbaikan || "").trim().length > 0;

  const setDecision = (key, textKey, value) => {
    const flagKey =
      key === "grinding_die_decision"
        ? "grinding_die_flag"
        : key === "grinding_punch_decision"
        ? "grinding_punch_flag"
        : "ganti_komponen_flag";

    setEngForm({
      ...engForm,
      [key]: value,
      [flagKey]: value === "YA",
      ...(value === "TIDAK" ? { [textKey]: "" } : {}),
    });
  };

  const OptionCard = ({ title, decisionKey, flagKey, textKey, placeholder }) => {
    const decision = String(engForm[decisionKey] || "").toUpperCase();
    const isYes = decision === "YA";
    const isNo = decision === "TIDAK";

    return (
      <div className={`wo-decision-card ${decision ? "selected" : ""}`}>
        <h4>{title}</h4>
        <div className="wo-actions" style={{ marginTop: 0 }}>
          <button
            type="button"
            className={`wo-btn ${isYes ? "wo-success" : "wo-muted"}`}
            onClick={() => setDecision(decisionKey, textKey, "YA")}
          >
            Ya
          </button>
          <button
            type="button"
            className={`wo-btn ${isNo ? "wo-danger" : "wo-muted"}`}
            onClick={() => setDecision(decisionKey, textKey, "TIDAK")}
          >
            Tidak
          </button>
        </div>

        {isYes && (
          <div className="wo-field" style={{ marginTop: 8 }}>
            <label>{placeholder}</label>
            <textarea
              value={engForm[textKey] || ""}
              onChange={(e) => setEngForm({ ...engForm, [textKey]: e.target.value, [flagKey]: true })}
              placeholder={placeholder}
            />
          </div>
        )}

        {!decision && (
          <div className="wo-decision-warning">
            Wajib pilih Ya atau Tidak
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="wo-card wo-engineering-panel">
      <h3>Proses Engineering: {selected.wo_no}</h3>

      <div className="wo-flow">
        <div><b>DISERAHKAN (PRODUKSI)</b>{selected.diserahkan_produksi_by || "-"}<br />{fmtDateTime(null, null, selected.diserahkan_produksi_at)}</div>
        <div><b>DITERIMA & DIPROSES (ENGINEERING)</b>{selected.diterima_engineering_by || "-"}<br />{fmtDateTime(null, null, selected.diterima_engineering_at)}</div>
        <div><b>DISERAHKAN KEMBALI (ENGINEERING)</b>{selected.diserahkan_kembali_engineering_by || "-"}<br />{fmtDateTime(null, null, selected.diserahkan_kembali_engineering_at)}</div>
        <div><b>DISERAHKAN KEMBALI (PRODUKSI)</b>{selected.diserahkan_kembali_produksi_by || "-"}<br />{fmtDateTime(null, null, selected.diserahkan_kembali_produksi_at)}</div>
      </div>

      <div className="wo-form-grid">
        <div className="wo-field">
          <label>Analisa Penyebab</label>
          <select
            value={engForm.analisa_penyebab}
            onChange={(e) => setEngForm({ ...engForm, analisa_penyebab: e.target.value })}
          >
            <option value="">-- pilih --</option>
            {analisaOptions.map((x) => <option key={x}>{x}</option>)}
          </select>
        </div>

        <div className="wo-field full">
          <label>Tindakan Perbaikan</label>
          <textarea
            value={engForm.tindakan_perbaikan}
            onChange={(e) => {
              const val = e.target.value;
              setEngForm({ ...engForm, tindakan_perbaikan: val });
            }}
            placeholder="Isi tindakan perbaikan. Setelah diisi, pilihan Grinding DIE / PUNCH / Ganti Komponen otomatis muncul."
          />
        </div>
      </div>

      {showDecisionCards && (
        <div className="wo-decision-grid">
          {/* SIP_WO_FOCUS_STABLE_OPTIONCARD_V1 */}
          {OptionCard({ title: 'Grinding DIE', decisionKey: 'grinding_die_decision', flagKey: 'grinding_die_flag', textKey: 'grinding_die', placeholder: 'Isi Grinding DIE' })}
          {/* SIP_WO_FOCUS_STABLE_OPTIONCARD_V1 */}
          {OptionCard({ title: 'Grinding PUNCH', decisionKey: 'grinding_punch_decision', flagKey: 'grinding_punch_flag', textKey: 'grinding_punch', placeholder: 'Isi Grinding PUNCH' })}
          {/* SIP_WO_FOCUS_STABLE_OPTIONCARD_V1 */}
          {OptionCard({ title: 'Ganti Komponen', decisionKey: 'ganti_komponen_decision', flagKey: 'ganti_komponen_flag', textKey: 'ganti_komponen', placeholder: 'Isi Ganti Komponen' })}
        </div>
      )}

      {/* SIP_WO_MANUAL_TIME_STAGING_R20 */}
      <div className="wo-form-grid" style={{ marginTop: 12 }}>
        <div className="wo-field">
          <label>Mulai Engineering (Manual)</label>
          <input
            type="datetime-local"
            value={
              engForm.tanggal_mulai && engForm.jam_mulai
                ? `${sipWoLocalDateV11(engForm.tanggal_mulai)}T${String(engForm.jam_mulai).slice(0, 5)}`
                : ""
            }
            onChange={(e) => {
              const [tanggal, jam] = String(e.target.value || "").split("T");
              setEngForm({
                ...engForm,
                tanggal_mulai: tanggal || "",
                jam_mulai: jam || "",
              });
            }}
          />
          <small style={{ color: "#64748b", fontWeight: 700 }}>
            Isi manual sesuai waktu aktual mulai pekerjaan Engineering.
          </small>
        </div>

        <div className="wo-field">
          <label>Selesai Engineering (Manual)</label>
          <input
            type="datetime-local"
            value={
              engForm.tanggal_selesai && engForm.jam_selesai
                ? `${sipWoLocalDateV11(engForm.tanggal_selesai)}T${String(engForm.jam_selesai).slice(0, 5)}`
                : ""
            }
            onChange={(e) => {
              const [tanggal, jam] = String(e.target.value || "").split("T");
              setEngForm({
                ...engForm,
                tanggal_selesai: tanggal || "",
                jam_selesai: jam || "",
              });
            }}
          />
          <small style={{ color: "#64748b", fontWeight: 700 }}>
            Isi manual sesuai waktu aktual pekerjaan Engineering selesai.
          </small>
        </div>

        <div className="wo-field">
          <label>Hasil</label>
          <select value={engForm.hasil} onChange={(e) => setEngForm({ ...engForm, hasil: e.target.value })}>
            <option>OK</option>
            <option>NG</option>
          </select>
        </div>
      </div>

      <div className="wo-actions">
        <button
          type="button"
          className="wo-btn wo-primary"
          onClick={saveEngineeringProgress}
        >
          SIMPAN
        </button>

        <button className="wo-btn wo-success" onClick={closeEngineering}>
          CLOSE
        </button>
      </div>
      {/* END SIP_WO_MANUAL_TIME_STAGING_R20 */}
    </div>
  );
}


function WorkflowTabFilterV3({ title, tabKey, filter, onChange, onReset, total, shown, options }) {
  const urgencyOptions = options?.urgencyOptions || [];
  const kategoriOptions = options?.kategoriOptions || [];
  const areaOptions = options?.areaOptions || [];
  const prosesOptions = options?.prosesOptions || [];

  const fieldStyle = { minWidth: 150 };

  return (
    <div className="wo-card no-print" style={{ marginBottom: 12 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 12 }}>
        <div>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <small style={{ color: "#64748b", fontWeight: 700 }}>
            Menampilkan {shown} dari {total} data
          </small>
        </div>
        <button className="wo-btn wo-muted" type="button" onClick={() => onReset(tabKey)}>
          Reset Filter
        </button>
      </div>

      <div className="wo-form-grid" style={{ alignItems: "end" }}>
        <div className="wo-field" style={{ gridColumn: "span 2", minWidth: 240 }}>
          <label>Cari</label>
          <input
            value={filter.q}
            onChange={(e) => onChange(tabKey, "q", e.target.value)}
            placeholder="WO / part / kode / line / masalah / ID mesin"
          />
        </div>

        <div className="wo-field" style={fieldStyle}>
          <label>Prioritas</label>
          <select value={filter.urgency} onChange={(e) => onChange(tabKey, "urgency", e.target.value)}>
            <option value="">Semua</option>
            {urgencyOptions.map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
        </div>

        <div className="wo-field" style={fieldStyle}>
          <label>Dampak</label>
          <select value={filter.kategori} onChange={(e) => onChange(tabKey, "kategori", e.target.value)}>
            <option value="">Semua</option>
            {kategoriOptions.map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
        </div>

        <div className="wo-field" style={fieldStyle}>
          <label>Area Dies</label>
          <select value={filter.area_dies} onChange={(e) => onChange(tabKey, "area_dies", e.target.value)}>
            <option value="">Semua</option>
            {areaOptions.map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
        </div>

        <div className="wo-field" style={fieldStyle}>
          <label>Proses</label>
          <select value={filter.proses} onChange={(e) => onChange(tabKey, "proses", e.target.value)}>
            <option value="">Semua</option>
            {prosesOptions.map((x) => <option key={x} value={x}>{x}</option>)}
          </select>
        </div>

        <div className="wo-field" style={fieldStyle}>
          <label>Line</label>
          <input
            value={filter.line}
            onChange={(e) => onChange(tabKey, "line", e.target.value)}
            placeholder="Cari line"
          />
        </div>

        <div className="wo-field" style={fieldStyle}>
          <label>Dari Tanggal</label>
          <input type="date" value={filter.date_from} onChange={(e) => onChange(tabKey, "date_from", e.target.value)} />
        </div>

        <div className="wo-field" style={fieldStyle}>
          <label>Sampai Tanggal</label>
          <input type="date" value={filter.date_to} onChange={(e) => onChange(tabKey, "date_to", e.target.value)} />
        </div>
      </div>
    </div>
  );
}

/* END SIP_WO_TAB_FILTER_V3 */

function RecapTable({
  title,
  list,
  showAction,
  actionMode,
  openEngineering,
  closeProduction,
  returnToEngineering,
  openProductionEdit,
  openMachinePicker,
  canAssignMachine,
  deleteWO,
  openChat
}) {
  return (
    <div className="wo-card">
      {title && <h3>{title}</h3>}
      <div className="wo-table-wrap">
        <table className="wo-table">
          <thead>
            <tr>
              <th>No WO</th><th>Status</th><th>Stage</th><th>Prioritas</th><th>Dampak</th><th>Area Dies</th><th>Nama Part</th><th>Line</th><th>Kode Part</th><th>Proses</th><th>ID Mesin</th>
              <th>Tgl/Jam Masuk</th><th>Uraian Masalah</th><th>Analisa</th><th>Tindakan</th><th>Grinding DIE</th><th>Grinding PUNCH</th><th>Ganti Komponen</th>
              <th>Mulai</th><th>Selesai</th><th>Hasil</th><th>Diserahkan Produksi</th><th>Diterima Engineering</th><th>Diserahkan Engineering</th><th>Closed Produksi</th>
              {showAction && <th className="no-print">Aksi</th>}
            </tr>
          </thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id}>
                <td><b>{r.wo_no}</b></td>
                <td><span className={statusClass(r.status_wo)}>{r.status_wo}</span></td>
                <td><span className="wo-stage-chip-v2">{r.workflow_stage || "-"}</span></td>
                <td>{String(r.workflow_stage || "").toUpperCase() === "WAITING_PPIC" ? "BELUM DITENTUKAN" : (r.urgency || "-")}</td><td>{r.kategori}</td><td>{r.area_dies}</td><td>{r.nama_part}</td><td>{r.line}</td><td>{r.kode_part}</td><td>{r.proses}</td><td>{r.machine_id || "-"}</td>
                <td>{fmtDate(r.tanggal_masuk)} {fmtTime(r.jam_masuk)}</td>
                <td style={{ whiteSpace: "normal", minWidth: 180 }}>{r.uraian_masalah}{r.produksi_return_note ? <><br /><b>Return Produksi:</b> {r.produksi_return_note}</> : null}</td>
                <td>{r.analisa_penyebab || "-"}</td>
                <td style={{ whiteSpace: "normal", minWidth: 220 }}>{r.tindakan_perbaikan || "-"}</td>
                <td>{r.grinding_die_flag ? (r.grinding_die || "YA") : "-"}</td>
                <td>{r.grinding_punch_flag ? (r.grinding_punch || "YA") : "-"}</td>
                <td>{r.ganti_komponen_flag ? (r.ganti_komponen || "YA") : "-"}</td>
                <td>{fmtDate(r.tanggal_mulai)} {fmtTime(r.jam_mulai)}</td>
                <td>{fmtDate(r.tanggal_selesai)} {fmtTime(r.jam_selesai)}</td>
                <td>{r.hasil || "-"}</td>
                <td>{r.diserahkan_produksi_by || "-"}</td>
                <td>{r.diterima_engineering_by || "-"}</td>
                <td>{r.diserahkan_kembali_engineering_by || "-"}</td>
                <td>{r.diserahkan_kembali_produksi_by || "-"}</td>
                {showAction && (
                  <td className="no-print">
                    <div className="wo-master-admin-final-actions">
                      {actionMode === "engineering" && <button className="wo-btn wo-primary" onClick={() => openEngineering(r)}>Proses Engineering</button>}
                      {actionMode === "production" &&
                        String(r.status_wo || "").toUpperCase() === "OPEN" &&
                        ["PPIC_RETURNED", ""].includes(
                          String(r.workflow_stage || "").toUpperCase()
                        ) && (
                        <button className="wo-btn wo-warning" onClick={() => openProductionEdit(r)}>Edit Produksi</button>
                      )}
                      {actionMode === "production" &&
                        String(r.workflow_stage || "").toUpperCase() === "WAITING_PRODUCTION_MACHINE" && (
                        canAssignMachine ? (
                          <button className="wo-btn wo-primary" onClick={() => openMachinePicker(r)}>Pilih Mesin</button>
                        ) : (
                          <span style={{ fontWeight: 800, color: "#64748b" }}>Menunggu user berhak pilih mesin</span>
                        )
                      )}
                      {actionMode === "production" &&
                        String(r.status_wo || "").toUpperCase() === "RESOLVED" &&
                        ["QUALITY_APPROVED", ""].includes(
                          String(r.workflow_stage || "").toUpperCase()
                        ) && (
                        <>
                          <button className="wo-btn wo-success" onClick={() => closeProduction(r)}>Terima OK / Close</button>
                          <button className="wo-btn wo-warning" onClick={() => returnToEngineering(r)}>REJECT Engineering</button>
                        </>
                      )}
                      {openChat && (
                        <button
                          className="wo-btn wo-muted"
                          onClick={() => openChat(r)}
                        >
                          💬 Chat
                        </button>
                      )}
                      {actionMode !== "production" && deleteWO && <button className="wo-btn wo-danger" onClick={() => deleteWO(r)}>Hapus</button>}
                    </div>
                  </td>
                )}
              </tr>
            ))}
            {!list.length && (
              <tr><td colSpan={showAction ? 26 : 25} style={{ textAlign: "center", padding: 20 }}>Belum ada data WO</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}


/* ================================================================
   SIP_WO_WORKFLOW_V2_HELPERS
   ================================================================ */

function woV2AuthHeaders(extra = {}) {
  const u = getStoredUser();
  return {
    Authorization: getToken() ? `Bearer ${getToken()}` : "",
    "X-User-Name": u?.username || u?.name || "admin",
    "X-User-Id": u?.id || "",
    ...extra,
  };
}

async function woV2Fetch(path, opts = {}) {
  const headers = {
    ...(opts.body instanceof FormData
      ? {}
      : { "Content-Type": "application/json" }),
    ...woV2AuthHeaders(),
    ...(opts.headers || {}),
  };

  const res = await fetch(`${API_V2}${path}`, {
    ...opts,
    headers,
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok || json.ok === false) {
    throw new Error(json.message || `HTTP ${res.status}`);
  }
  return json;
}

function fmtMinutesV2(v) {
  const n = Math.max(0, Number(v || 0));
  if (n < 60) return `${Math.round(n)} menit`;
  const h = Math.floor(n / 60);
  const m = Math.round(n % 60);
  return `${h} jam ${m} menit`;
}

function AdvancedFilterBoxV2({
  filters,
  setFilters,
  loadList,
  options
}) {
  const [showAdvanced, setShowAdvanced] = useState(false);

  const set = (key, value) =>
    setFilters({
      ...filters,
      [key]: value
    });

  const cleanFilters = {
    status: "",
    workflow_stage: "",
    urgency: "",
    kategori: "",
    area_dies: "",
    line: "",
    proses: "",
    ppic_status: "",
    quality_status: "",
    hasil: "",
    created_by: "",
    ppic_approver: "",
    engineering_pic: "",
    quality_approver: "",
    grinding_die: "",
    grinding_punch: "",
    ganti_komponen: "",
    mttr_min: "",
    mttr_max: "",
    overdue: "",
    date_from: "",
    date_to: "",
    q: "",
  };

  const activeAdvanced = [
    filters.workflow_stage,
    filters.ppic_status,
    filters.quality_status,
    filters.hasil,
    filters.created_by,
    filters.ppic_approver,
    filters.engineering_pic,
    filters.quality_approver,
    filters.grinding_die,
    filters.grinding_punch,
    filters.ganti_komponen,
    filters.mttr_min,
    filters.mttr_max,
    filters.overdue,
  ].filter((x) => String(x || "").trim() !== "").length;

  const reset = () => {
    setFilters(cleanFilters);
    setShowAdvanced(false);

    /*
     * Pertahankan mekanisme reload existing tanpa menambah
     * perubahan lain pada fungsi loadList.
     */
    setTimeout(() => loadList(cleanFilters), 0);
  };

  return (
    <div className="wo-card wo-filter-compact-v15 no-print">
      <div className="wo-filter-head-v15">
        <div>
          <h3>Filter Work Order</h3>
          <p>
            Filter utama ditampilkan ringkas.
            Filter detail tetap tersedia di Filter Lanjutan.
          </p>
        </div>

        <button
          type="button"
          className={
            `wo-btn ${
              showAdvanced
                ? "wo-primary"
                : "wo-muted"
            }`
          }
          onClick={() =>
            setShowAdvanced((v) => !v)
          }
        >
          {showAdvanced
            ? "TUTUP FILTER LANJUTAN"
            : `FILTER LANJUTAN${
                activeAdvanced
                  ? ` (${activeAdvanced})`
                  : ""
              }`}
        </button>
      </div>

      <div className="wo-filter-section-v15">
        <div className="wo-filter-section-title-v15">
          Filter Utama
        </div>

        <div className="wo-filter-main-grid-v15">
          <div className="wo-field">
            <label>Status</label>
            <select
              value={filters.status}
              onChange={(e) =>
                set("status", e.target.value)
              }
            >
              <option value="">Semua Status</option>
              {[
                "OPEN",
                "PROGRESS",
                "RESOLVED",
                "CLOSED"
              ].map((x) => (
                <option key={x}>{x}</option>
              ))}
            </select>
          </div>

          <div className="wo-field">
            <label>Prioritas</label>
            <select
              value={filters.urgency}
              onChange={(e) =>
                set("urgency", e.target.value)
              }
            >
              <option value="">Semua Prioritas</option>
              {options.urgencyOptions.map((x) => (
                <option key={x}>{x}</option>
              ))}
            </select>
          </div>

          <div className="wo-field">
            <label>Dampak</label>
            <select
              value={filters.kategori}
              onChange={(e) =>
                set("kategori", e.target.value)
              }
            >
              <option value="">Semua Dampak</option>
              {options.kategoriOptions.map((x) => (
                <option key={x}>{x}</option>
              ))}
            </select>
          </div>

          <div className="wo-field">
            <label>Area DIES</label>
            <select
              value={filters.area_dies}
              onChange={(e) =>
                set("area_dies", e.target.value)
              }
            >
              <option value="">Semua Area DIES</option>
              {options.areaOptions.map((x) => (
                <option key={x}>{x}</option>
              ))}
            </select>
          </div>

          <div className="wo-field">
            <label>Line</label>
            <input
              value={filters.line}
              onChange={(e) =>
                set("line", e.target.value)
              }
              placeholder="Semua Line"
            />
          </div>

          <div className="wo-field">
            <label>Proses</label>
            <select
              value={filters.proses}
              onChange={(e) =>
                set("proses", e.target.value)
              }
            >
              <option value="">Semua Proses</option>
              {options.prosesOptions.map((x) => (
                <option key={x}>{x}</option>
              ))}
            </select>
          </div>

          <div className="wo-field">
            <label>Dari Tanggal</label>
            <input
              type="date"
              value={filters.date_from}
              onChange={(e) =>
                set("date_from", e.target.value)
              }
            />
          </div>

          <div className="wo-field">
            <label>Sampai Tanggal</label>
            <input
              type="date"
              value={filters.date_to}
              onChange={(e) =>
                set("date_to", e.target.value)
              }
            />
          </div>
        </div>

        <div className="wo-filter-search-v15">
          <div className="wo-field">
            <label>Cari</label>
            <input
              value={filters.q}
              onChange={(e) =>
                set("q", e.target.value)
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  loadList();
                }
              }}
              placeholder="No WO / part / kode / line / proses / masalah"
            />
          </div>

          <button
            type="button"
            className="wo-btn wo-primary"
            onClick={() => loadList()}
          >
            TAMPILKAN
          </button>

          <button
            type="button"
            className="wo-btn wo-muted"
            onClick={reset}
          >
            RESET
          </button>
        </div>
      </div>

      {showAdvanced && (
        <div className="wo-filter-advanced-v15">
          <div className="wo-filter-section-title-v15">
            Filter Lanjutan
          </div>

          <div className="wo-filter-advanced-grid-v15">
            <div className="wo-field">
              <label>Workflow Stage</label>
              <select
                value={filters.workflow_stage}
                onChange={(e) =>
                  set(
                    "workflow_stage",
                    e.target.value
                  )
                }
              >
                <option value="">Semua Stage</option>
                {[
                  "WAITING_PPIC",
                  "PPIC_RETURNED",
                  "READY_ENGINEERING",
                  "ENGINEERING_PROCESS",
                  "ENGINEERING_REWORK",
                  "WAITING_PRODUCTION_MACHINE",
                  "WAITING_QUALITY",
                  "QUALITY_APPROVED",
                  "COMPLETED"
                ].map((x) => (
                  <option key={x}>{x}</option>
                ))}
              </select>
            </div>

            <div className="wo-field">
              <label>Approval PPIC</label>
              <select
                value={filters.ppic_status}
                onChange={(e) =>
                  set(
                    "ppic_status",
                    e.target.value
                  )
                }
              >
                <option value="">Semua</option>
                {[
                  "PENDING",
                  "APPROVED",
                  "RETURNED"
                ].map((x) => (
                  <option key={x}>{x}</option>
                ))}
              </select>
            </div>

            <div className="wo-field">
              <label>Approval Quality</label>
              <select
                value={filters.quality_status}
                onChange={(e) =>
                  set(
                    "quality_status",
                    e.target.value
                  )
                }
              >
                <option value="">Semua</option>
                {[
                  "PENDING",
                  "APPROVED",
                  "RETURNED",
                  "RETURNED_BY_PRODUCTION"
                ].map((x) => (
                  <option key={x}>{x}</option>
                ))}
              </select>
            </div>

            <div className="wo-field">
              <label>Hasil</label>
              <select
                value={filters.hasil}
                onChange={(e) =>
                  set("hasil", e.target.value)
                }
              >
                <option value="">Semua</option>
                <option>OK</option>
                <option>NG</option>
              </select>
            </div>

            <div className="wo-field">
              <label>User Produksi</label>
              <input
                value={filters.created_by}
                onChange={(e) =>
                  set(
                    "created_by",
                    e.target.value
                  )
                }
                placeholder="Nama user"
              />
            </div>

            <div className="wo-field">
              <label>PPIC Approver</label>
              <input
                value={filters.ppic_approver}
                onChange={(e) =>
                  set(
                    "ppic_approver",
                    e.target.value
                  )
                }
                placeholder="Nama user"
              />
            </div>

            <div className="wo-field">
              <label>Engineering PIC</label>
              <input
                value={filters.engineering_pic}
                onChange={(e) =>
                  set(
                    "engineering_pic",
                    e.target.value
                  )
                }
                placeholder="Nama user"
              />
            </div>

            <div className="wo-field">
              <label>Quality Approver</label>
              <input
                value={filters.quality_approver}
                onChange={(e) =>
                  set(
                    "quality_approver",
                    e.target.value
                  )
                }
                placeholder="Nama user"
              />
            </div>

            <div className="wo-field">
              <label>Grinding DIE</label>
              <select
                value={filters.grinding_die}
                onChange={(e) =>
                  set(
                    "grinding_die",
                    e.target.value
                  )
                }
              >
                <option value="">Semua</option>
                <option>YA</option>
                <option>TIDAK</option>
              </select>
            </div>

            <div className="wo-field">
              <label>Grinding PUNCH</label>
              <select
                value={filters.grinding_punch}
                onChange={(e) =>
                  set(
                    "grinding_punch",
                    e.target.value
                  )
                }
              >
                <option value="">Semua</option>
                <option>YA</option>
                <option>TIDAK</option>
              </select>
            </div>

            <div className="wo-field">
              <label>Ganti Komponen</label>
              <select
                value={filters.ganti_komponen}
                onChange={(e) =>
                  set(
                    "ganti_komponen",
                    e.target.value
                  )
                }
              >
                <option value="">Semua</option>
                <option>YA</option>
                <option>TIDAK</option>
              </select>
            </div>

            <div className="wo-field">
              <label>Aging</label>
              <select
                value={filters.overdue}
                onChange={(e) =>
                  set(
                    "overdue",
                    e.target.value
                  )
                }
              >
                <option value="">Semua</option>
                <option value="1">
                  Lebih dari 24 Jam
                </option>
              </select>
            </div>

            <div className="wo-field">
              <label>MTTR Min (menit)</label>
              <input
                type="number"
                min="0"
                value={filters.mttr_min}
                onChange={(e) =>
                  set(
                    "mttr_min",
                    e.target.value
                  )
                }
                placeholder="Min"
              />
            </div>

            <div className="wo-field">
              <label>MTTR Max (menit)</label>
              <input
                type="number"
                min="0"
                value={filters.mttr_max}
                onChange={(e) =>
                  set(
                    "mttr_max",
                    e.target.value
                  )
                }
                placeholder="Max"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function DashboardOverviewV2({ list }) {
  const now = new Date();
  const first = new Date(now.getFullYear(), now.getMonth(), 1);

  const iso = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  const [from, setFrom] = useState(iso(first));
  const [to, setTo] = useState(iso(now));

  const rows = useMemo(() => {
    return (list || []).filter((r) => {
      const d = sipWoLocalDateV11(r.tanggal_masuk || "");
      if (from && d && d < from) return false;
      if (to && d && d > to) return false;
      return true;
    });
  }, [list, from, to]);

  const total = rows.length;
  const priority = (v) => String(v || "").toUpperCase();
  const stage = (v) => String(v || "").toUpperCase();
  const status = (v) => String(v || "").toUpperCase();

  const high = rows.filter((r) => ["HIGH","URGENT"].includes(priority(r.urgency))).length;
  const critical = rows.filter((r) => priority(r.urgency) === "CRITICAL").length;
  const inProgress = rows.filter((r) => status(r.status_wo) === "PROGRESS").length;
  const waiting = rows.filter((r) => ["WAITING_PPIC","WAITING_PRODUCTION_MACHINE","WAITING_QUALITY"].includes(stage(r.workflow_stage))).length;
  const completed = rows.filter((r) => ["RESOLVED","CLOSED"].includes(status(r.status_wo))).length;

  const overdue = rows.filter((r) => {
    if (!["OPEN","PROGRESS"].includes(status(r.status_wo))) return false;
    const raw = `${sipWoLocalDateV11(r.tanggal_masuk || "")}T${String(r.jam_masuk || "00:00:00").slice(0,8)}`;
    const d = new Date(raw);
    return !Number.isNaN(d.getTime()) && (Date.now() - d.getTime()) > 24*3600*1000;
  }).length;

  const mttrRows = rows
    .map((r) => Number(r.mttr_minutes))
    .filter((x) => Number.isFinite(x) && x >= 0);
  const avgMttr = mttrRows.length
    ? Math.round(mttrRows.reduce((a,b) => a+b,0) / mttrRows.length)
    : 0;

  const statusData = ["OPEN","PROGRESS","RESOLVED","CLOSED"].map((x) => ({
    label:x,
    value:rows.filter((r) => status(r.status_wo) === x).length
  }));

  const pOpen = pct(statusData[0].value,total);
  const pProg = pct(statusData[1].value,total);
  const pRes = pct(statusData[2].value,total);

  const donut = total
    ? `conic-gradient(#ef4444 0 ${pOpen}%, #f59e0b ${pOpen}% ${pOpen+pProg}%, #3b82f6 ${pOpen+pProg}% ${pOpen+pProg+pRes}%, #22c55e ${pOpen+pProg+pRes}% 100%)`
    : "conic-gradient(#e5e7eb 0 100%)";

  const byPriority = groupCount(rows, "urgency", "BELUM DITENTUKAN").slice(0,30);
  const byImpact = groupCount(rows, "kategori").slice(0,8);
  const byArea = groupCount(rows, "area_dies").slice(0,8);

  const trendMap = {};
  rows.forEach((r) => {
    const d = sipWoLocalDateV11(r.tanggal_masuk || "");
    if (d) trendMap[d] = (trendMap[d] || 0) + 1;
  });

  const trend = Object.entries(trendMap)
    .sort(([a],[b]) => a.localeCompare(b))
    .slice(-20);
  const maxTrend = Math.max(1, ...trend.map(([,v]) => v));

  const recent = [...rows]
    .sort((a,b) => Number(b.id||0)-Number(a.id||0))
    .slice(0,8);

  return (
    <div className="wo-dash wo-dashboard-v2">
      <div className="wo-card no-print">
        <div className="wo-form-grid">
          <div className="wo-field"><label>Dari Tanggal</label><input type="date" value={from} onChange={(e)=>setFrom(e.target.value)} /></div>
          <div className="wo-field"><label>Sampai Tanggal</label><input type="date" value={to} onChange={(e)=>setTo(e.target.value)} /></div>
          <div className="wo-field"><label>Range Aktif</label><input disabled value={`${from || "-"} s/d ${to || "-"}`} /></div>
        </div>
      </div>

      <div className="wo-dash-grid-v2">
        <DashKpi title="Total Work Order" value={total} icon="📋" hint="Sesuai range tanggal" tone="blue" />
        <DashKpi title="High Priority" value={high} icon="⚠️" hint="HIGH + URGENT" tone="orange" />
        <DashKpi title="Critical" value={critical} icon="🚨" hint="CRITICAL" tone="purple" />
        <DashKpi title="In Progress" value={inProgress} icon="⚙️" hint="Status PROGRESS" tone="orange" />
        <DashKpi title="Waiting Approval" value={waiting} icon="🕒" hint="PPIC + Quality" tone="blue" />
        <DashKpi title="Completed" value={completed} icon="✅" hint="RESOLVED + CLOSED" tone="green" />
        <DashKpi title="Overdue >24 Jam" value={overdue} icon="⏰" hint="Indikator aging operasional" tone="orange" />
        <DashKpi title="AVG MTTR" value={`${avgMttr} mnt`} icon="⏱️" hint="Rata-rata data lengkap" tone="purple" />
      </div>

      <div className="wo-dash-main">
        <div className="wo-dash-card">
          <div className="wo-card-title"><div><h3>Work Order Status</h3><p>Komposisi status pada range tanggal</p></div></div>
          <div className="wo-donut-wrap">
            <div className="wo-donut" style={{background:donut}}>
              <div className="wo-donut-center"><b>{total}</b><span>Total WO</span></div>
            </div>
            <div className="wo-donut-legend">
              {statusData.map((x) => (
                <div className="wo-legend-row" key={x.label}>
                  <span className="wo-legend-dot" />
                  <span>{x.label}</span>
                  <b>{x.value}</b>
                  <small>{pct(x.value,total)}%</small>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="wo-dash-card">
          <div className="wo-card-title"><div><h3>Trend Work Order</h3><p>Jumlah WO per tanggal</p></div></div>
          <div className="wo-trend-v2">
            {trend.map(([d,v]) => (
              <div className="wo-trend-item-v2" key={d} title={`${d}: ${v}`}>
                <b>{v}</b>
                <div style={{height:`${Math.max(8,Math.round(v/maxTrend*140))}px`}} />
                <span>{d.slice(5)}</span>
              </div>
            ))}
            {!trend.length && <div className="wo-empty-state">Belum ada data pada range tanggal.</div>}
          </div>
        </div>
      </div>

      <div className="wo-dash-main wo-dash-main-3">
        <div className="wo-dash-card"><div className="wo-card-title"><div><h3>Prioritas</h3><p>Distribusi prioritas PPIC</p></div></div><BarList data={byPriority} total={total} emptyText="Belum ada data" /></div>
        <div className="wo-dash-card"><div className="wo-card-title"><div><h3>Dampak</h3><p>Distribusi dampak WO</p></div></div><BarList data={byImpact} total={total} emptyText="Belum ada data" /></div>
        <div className="wo-dash-card"><div className="wo-card-title"><div><h3>Area DIES</h3><p>Distribusi Area DIES</p></div></div><BarList data={byArea} total={total} emptyText="Belum ada data" /></div>
      </div>

      <div className="wo-dash-card wo-recent-auto-card-v16">
        <div className="wo-card-title">
          <div>
            <h3>Recent Activity / WO</h3>
            <p>WO terbaru bergerak otomatis menampilkan data berikutnya.</p>
          </div>
        </div>

        <div className="wo-recent-viewport-v16">
          {recent.length > 0 ? (
            <div
              className={
                `wo-recent-track-v16 ${
                  recent.length > 3
                    ? "is-scrolling"
                    : ""
                }`
              }
            >
              {[...recent, ...recent].map((r, idx) => (
                <div
                  className="wo-activity-item wo-recent-item-v16"
                  key={`${r.id}-${idx}`}
                >
                  <div className="wo-activity-icon">
                    🛠️
                  </div>

                  <div>
                    <b>{r.wo_no}</b>
                    <span>
                      {r.nama_part || "-"}
                      {" • "}
                      {r.line || "-"}
                      {" • "}
                      {r.workflow_stage || r.status_wo}
                    </span>
                  </div>

                  <span>
                    {fmtDate(r.tanggal_masuk)}
                    {" "}
                    {fmtTime(r.jam_masuk)}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div className="wo-empty-state">
              Belum ada WO.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* SIP_WO_RECENT_MULTITAG_V16_FRONTEND */

function PpicApprovalPanelV2({ rows, approve, reject, openChat, openHistory, canApprove }) {
  const [priority, setPriority] = useState({});
  const [note, setNote] = useState({});

  return (
    <>
      <div className="wo-card wo-workflow-head-v2">
        <div>
          <h3>PPIC Approval</h3>
          <p>List WO baru yang menunggu penentuan Prioritas oleh PPIC.</p>
        </div>
        <span className="wo-count-pill-v2">{rows.length} Pending</span>
      </div>

      <div className="wo-card">
        <div className="wo-table-wrap">
          <table className="wo-table wo-workflow-table-v2">
            <thead>
              <tr>
                <th>No WO</th><th>Tgl/Jam</th><th>Produksi</th><th>Dampak</th><th>Area DIES</th>
                <th>Part</th><th>Line</th><th>Proses</th><th>Masalah</th><th>Lama Menunggu</th>
                <th>Prioritas PPIC</th><th>Catatan</th><th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td><b>{r.wo_no}</b></td>
                  <td>{fmtDate(r.tanggal_masuk)} {fmtTime(r.jam_masuk)}</td>
                  <td>{r.diserahkan_produksi_by || "-"}</td>
                  <td>{r.kategori || "-"}</td>
                  <td>{r.area_dies || "-"}</td>
                  <td>{r.nama_part || "-"}</td>
                  <td>{r.line || "-"}</td>
                  <td>{r.proses || "-"}</td>
                  <td style={{whiteSpace:"normal", minWidth:220}}>{r.uraian_masalah || "-"}</td>
                  <td>{fmtMinutesV2(r.waiting_minutes)}</td>
                  <td>
                    <select value={priority[r.id] || ""} onChange={(e)=>setPriority({...priority,[r.id]:e.target.value})}>
                      <option value="">-- pilih --</option>
                      {["LOW","NORMAL","HIGH","URGENT","CRITICAL"].map((x)=><option key={x}>{x}</option>)}
                    </select>
                  </td>
                  <td>
                    <input value={note[r.id] || ""} onChange={(e)=>setNote({...note,[r.id]:e.target.value})} placeholder="Catatan opsional" />
                  </td>
                  <td>
                    <div className="wo-actions">
                      {canApprove && (
                        <>
                          <button className="wo-btn wo-success" disabled={!priority[r.id]} onClick={()=>approve(r, priority[r.id], note[r.id] || "")}>APPROVE</button>
                          <button className="wo-btn wo-warning" onClick={()=>reject(r)}>REJECT</button>
                        </>
                      )}
                      {openChat && <button className="wo-btn wo-muted" onClick={()=>openChat(r)}>💬 Chat</button>}
                      <button className="wo-btn wo-muted" onClick={()=>openHistory(r)}>📜</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan="13" style={{textAlign:"center",padding:24}}>Tidak ada WO menunggu approval PPIC.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

function QualityApprovalPanelV2({ rows, approve, reject, openFiles, openChat, openHistory, canApprove }) {
  return (
    <>
      <div className="wo-card wo-workflow-head-v2">
        <div>
          <h3>Quality Approval</h3>
          <p>Engineering sudah CLOSE dan ID Mesin sudah dipilih Produksi. Status tetap PROGRESS sampai Quality APPROVE.</p>
        </div>
        <span className="wo-count-pill-v2">{rows.length} Pending</span>
      </div>

      <div className="wo-card">
        <div className="wo-table-wrap">
          <table className="wo-table wo-workflow-table-v2">
            <thead>
              <tr>
                <th>No WO</th><th>Prioritas</th><th>Dampak</th><th>Area DIES</th><th>Part</th><th>Line</th><th>Proses</th><th>ID Mesin</th>
                <th>Masalah</th><th>Analisa</th><th>Tindakan</th><th>Hasil</th><th>Engineer</th><th>Close Eng.</th><th>Foto</th><th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td><b>{r.wo_no}</b></td>
                  <td>{r.urgency || "-"}</td>
                  <td>{r.kategori || "-"}</td>
                  <td>{r.area_dies || "-"}</td>
                  <td>{r.nama_part || "-"}</td>
                  <td>{r.line || "-"}</td>
                  <td>{r.proses || "-"}</td>
                  <td><b>{r.machine_id || "-"}</b></td>
                  <td style={{whiteSpace:"normal",minWidth:200}}>{r.uraian_masalah || "-"}</td>
                  <td style={{whiteSpace:"normal",minWidth:180}}>{r.analisa_penyebab || "-"}</td>
                  <td style={{whiteSpace:"normal",minWidth:220}}>{r.tindakan_perbaikan || "-"}</td>
                  <td>{r.hasil || "-"}</td>
                  <td>{r.diterima_engineering_by || "-"}</td>
                  <td>{r.engineering_closed_at ? new Date(r.engineering_closed_at).toLocaleString("id-ID") : "-"}</td>
                  <td><button className="wo-btn wo-muted" onClick={()=>openFiles(r)}>📷 {r.attachment_count || 0}</button></td>
                  <td>
                    <div className="wo-actions">
                      {canApprove && (
                        <>
                          <button className="wo-btn wo-success" onClick={()=>approve(r)}>APPROVE</button>
                          <button className="wo-btn wo-warning" onClick={()=>reject(r)}>REJECT</button>
                        </>
                      )}
                      {openChat && <button className="wo-btn wo-muted" onClick={()=>openChat(r)}>💬 Chat</button>}
                      <button className="wo-btn wo-muted" onClick={()=>openHistory(r)}>📜</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan="16" style={{textAlign:"center",padding:24}}>Tidak ada WO menunggu approval Quality.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}


// SIP_WO_MACHINE_SEARCH_V1 - isolated production patch
function MachinePickerModalV2({ wo, machines, selectedId, setSelectedId, onOk, onCancel }) {
  const [machineSearch, setMachineSearch] = useState("");
  const selected = machines.find((m) => String(m.id) === String(selectedId));
  const search = machineSearch.trim().toLocaleLowerCase("id-ID");
  const filteredMachines = machines.filter((m) =>
    [m.machine_id, m.machine_name, m.line]
      .some((value) => String(value ?? "").toLocaleLowerCase("id-ID").includes(search))
  );
  // Pertahankan opsi terpilih agar select tidak kosong saat hasil pencarian berubah.
  const visibleMachines = selected && !filteredMachines.some((m) => String(m.id) === String(selected.id))
    ? [selected, ...filteredMachines]
    : filteredMachines;

  return createPortal(
    <div className="wo-page">
      <div className="wo-modal-overlay-v2" onClick={onCancel}>
        <div className="wo-modal-v2" style={{ width: "min(620px, 96vw)" }} onClick={(e) => e.stopPropagation()}>
          <div className="wo-modal-head-v2">
            <div>
              <h3>Pilih ID Mesin - {wo.wo_no}</h3>
              <p>Setelah klik OK, WO akan masuk ke tab Quality. Cancel tidak mengubah WO.</p>
            </div>
            <button className="wo-btn wo-muted" type="button" onClick={onCancel}>✕</button>
          </div>

          <div className="wo-field">
            <label htmlFor="wo-machine-search-v1">Cari Mesin (ID, nama, atau line)</label>
            <input
              id="wo-machine-search-v1"
              type="search"
              autoComplete="off"
              placeholder="Contoh: SIP-PR, CHIN FONG, D12"
              value={machineSearch}
              onChange={(e) => setMachineSearch(e.target.value)}
              style={{ width: "100%", boxSizing: "border-box", marginBottom: 10 }}
            />
            <label htmlFor="wo-machine-select-v1">ID Mesin</label>
            <select id="wo-machine-select-v1" value={selectedId} onChange={(e) => setSelectedId(e.target.value)}>
              <option value="">-- pilih ID mesin --</option>
              {visibleMachines.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.machine_id}{m.machine_name ? ` - ${m.machine_name}` : ""}{m.line ? ` (${m.line})` : ""}
                </option>
              ))}
            </select>
            <small style={{ display: "block", marginTop: 6 }}>
              {filteredMachines.length} dari {machines.length} mesin cocok
            </small>
            {search && filteredMachines.length === 0 && (
              <div className="wo-msg" style={{ marginTop: 8 }}>Mesin tidak ditemukan. Coba ID, nama, atau line lain.</div>
            )}
          </div>

          {selected && (
            <div className="wo-card" style={{ marginTop: 12, boxShadow: "none" }}>
              <b>{selected.machine_id}</b>
              <div>{selected.machine_name || "-"}</div>
              <small>Line: {selected.line || "-"}</small>
            </div>
          )}

          {!machines.length && (
            <div className="wo-msg" style={{ marginTop: 12 }}>Belum ada master mesin. Tambahkan dari tab Master Admin.</div>
          )}

          <div className="wo-actions" style={{ justifyContent: "flex-end", marginTop: 16 }}>
            <button className="wo-btn wo-muted" type="button" onClick={onCancel}>Cancel</button>
            <button className="wo-btn wo-success" type="button" disabled={!selectedId} onClick={onOk}>OK</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

/* ================================================================
   SIP_WO_CHAT_CENTER_V3_FRONTEND
   ================================================================ */


/* ================================================================
   SIP_WO_FLOATING_CHAT_V4
   ================================================================ */

function WoFloatingChatV4({ list, unread, onUnreadRefresh }) {
  const [open, setOpen] = useState(false);
  const unreadCount = Number(unread?.TOTAL || 0);


  if (typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className="wo-page wo-floating-chat-root-v5">
      {/* SIP_WO_FLOATING_CHAT_V5_PORTAL */}

      {open && (
        <>
          <div
            className="wo-floating-chat-backdrop-v5"
            aria-hidden="true"
          />

          <aside
            className="wo-floating-chat-panel-v5"
            aria-label="Chat Work Order"
          >
            <div className="wo-floating-chat-panel-head-v5">
              <div className="wo-floating-chat-title-v5">
                <span className="wo-messenger-mini-v5" aria-hidden="true">
                  <svg viewBox="0 0 24 24" role="img">
                    <path
                      fill="currentColor"
                      d="M12 2C6.477 2 2 6.145 2 11.259c0 2.91 1.45 5.505 3.715 7.203V22l3.393-1.865c.915.253 1.885.389 2.892.389 5.523 0 10-4.145 10-9.265C22 6.145 17.523 2 12 2Zm1.052 12.47-2.548-2.72-4.97 2.72 5.466-5.802 2.61 2.72 4.908-2.72-5.466 5.802Z"
                    />
                  </svg>
                </span>

                <div>
                  <b>Chat Work Order</b>
                  <span>
                    @Produksi / @PPIC / @Engineering / @Quality
                  </span>
                </div>
              </div>

              <button
                type="button"
                className="wo-floating-chat-close-v5"
                onClick={() => setOpen(false)}
                aria-label="Tutup Chat"
                title="Tutup"
              >
                ×
              </button>
            </div>

            <div className="wo-floating-chat-panel-body-v5">
              <WoChatCenterV3
                list={list}
                unread={unread}
                onUnreadRefresh={onUnreadRefresh}
              />
            </div>
          </aside>
        </>
      )}

      <button
        type="button"
        className={
          `wo-floating-chat-button-v5 ${
            open ? "is-open" : ""
          }`
        }
        onClick={() => setOpen(true)}
        aria-label="Buka Chat Work Order"
        title="Chat Work Order"
      >
        <svg
          className="wo-messenger-icon-v5"
          viewBox="0 0 24 24"
          role="img"
          aria-hidden="true"
        >
          <path
            fill="currentColor"
            d="M12 2C6.477 2 2 6.145 2 11.259c0 2.91 1.45 5.505 3.715 7.203V22l3.393-1.865c.915.253 1.885.389 2.892.389 5.523 0 10-4.145 10-9.265C22 6.145 17.523 2 12 2Zm1.052 12.47-2.548-2.72-4.97 2.72 5.466-5.802 2.61 2.72 4.908-2.72-5.466 5.802Z"
          />
        </svg>

        {unreadCount > 0 && (
          <span className="wo-floating-chat-badge-v5">
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>
    </div>,
    document.body
  );
}


function WoChatCenterV3({ list, unread, onUnreadRefresh }) {
  const [rows, setRows] = useState([]);
  const [message, setMessage] = useState("");
  const [woNo, setWoNo] = useState("");
  const [filterRole, setFilterRole] = useState("");
  const [search, setSearch] = useState("");
  const [busy, setBusy] = useState(false);
  const [statusText, setStatusText] = useState("");

  const me = getStoredUser();
  const myName = me?.username || me?.name || "admin";

  const tags = [
    { label: "@Produksi", role: "PRODUCTION" },
    { label: "@PPIC", role: "PPIC" },
    { label: "@Engineering", role: "ENGINEERING" },
    { label: "@Quality", role: "QUALITY" },
  ];

  const woOptions = useMemo(() => {
    const seen = new Set();
    const out = [];

    (list || []).forEach((r) => {
      const key = String(r.wo_no || "").trim();

      if (!key || seen.has(key)) return;

      seen.add(key);

      out.push({
        wo_no: key,
        nama_part: r.nama_part || "",
        line: r.line || "",
      });
    });

    return out.slice(0, 5000);
  }, [list]);

  const hasValidTag = (text) =>
    /@(produksi|production|ppic|engineering|quality)\b/i
      .test(String(text || ""));

  const chooseTag = (tag) => {
    const current = String(message || "").trim();

    const tagExists = new RegExp(
      `(^|\\s)${tag.label.replace("@", "\\@")}\\b`,
      "i"
    ).test(current);

    if (tagExists) {
      return;
    }

    setMessage(
      current
        ? `${current} ${tag.label} `
        : `${tag.label} `
    );
  };

  const load = async () => {
    const qs = new URLSearchParams();

    if (filterRole) {
      qs.set("target_role", filterRole);
    }

    if (search.trim()) {
      qs.set("q", search.trim());
    }

    const x = await woV2Fetch(
      `/chat-center-multi?${qs.toString()}`
    );

    setRows(x.data || []);

    await woV2Fetch(
      "/chat-center-multi/read",
      {
        method: "POST",
        body: "{}"
      }
    ).catch(() => {});

    if (onUnreadRefresh) {
      await onUnreadRefresh();
    }
  };

  useEffect(() => {
    load().catch((e) => {
      setStatusText(e.message);
    });

    const timer = setInterval(() => {
      load().catch(() => {});
    }, 15000);

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterRole]);

  const send = async () => {
    const clean = String(message || "").trim();

    if (!clean) {
      setStatusText("Pesan belum diisi.");
      return;
    }

    if (!hasValidTag(clean)) {
      setStatusText(
        "Tag tujuan dulu: @Produksi, @PPIC, @Engineering, atau @Quality."
      );
      return;
    }

    setBusy(true);
    setStatusText("");

    try {
      const x = await woV2Fetch(
        "/chat-center-multi",
        {
          method: "POST",
          body: JSON.stringify({
            message: clean,
            wo_no: String(woNo || "").trim(),
          }),
        }
      );

      setMessage("");
      setWoNo("");

      setStatusText(
        `Pesan terkirim ke ${
          x.mention_tags ||
          x.mention_tag ||
          x.target_role ||
          "bagian tujuan"
        }.`
      );

      await load();
    } catch (e) {
      setStatusText(e.message);
    } finally {
      setBusy(false);
    }
  };

  const doSearch = () => {
    load().catch((e) => {
      setStatusText(e.message);
    });
  };

  return (
    <div className="wo-chat-center-v3">
      <div className="wo-card wo-chat-center-head-v3">
        <div>
          <h3>💬 Chat Work Order</h3>
          <p>
            Chat umum aplikasi WO. Tujuan menggunakan tag bagian,
            bukan memilih user dan bukan chat per case.
          </p>
        </div>

        <div className="wo-chat-center-unread-v3">
          <span>Pesan Baru</span>
          <b>{Number(unread?.TOTAL || 0)}</b>
        </div>
      </div>

      <div className="wo-card">
        <div className="wo-chat-compose-head-v3">
          <b>Tag bagian tujuan terlebih dahulu</b>

          <div className="wo-tag-buttons-v3">
            {tags.map((tag) => (
              <button
                type="button"
                key={tag.role}
                className="wo-tag-btn-v3"
                onClick={() => chooseTag(tag)}
              >
                {tag.label}
              </button>
            ))}
          </div>
        </div>

        <div className="wo-chat-compose-grid-v3">
          <div className="wo-field">
            <label>Referensi No. WO (opsional)</label>

            <input
              list="wo-chat-center-list-v3"
              value={woNo}
              onChange={(e) => setWoNo(e.target.value)}
              placeholder="Contoh: WO-20260827-0001"
            />

            <datalist id="wo-chat-center-list-v3">
              {woOptions.map((x) => (
                <option
                  key={x.wo_no}
                  value={x.wo_no}
                >
                  {x.nama_part}
                  {x.line ? ` - ${x.line}` : ""}
                </option>
              ))}
            </datalist>
          </div>

          <div className="wo-field wo-chat-message-field-v3">
            <label>Pesan</label>

            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => {
                if (
                  e.key === "Enter" &&
                  !e.shiftKey
                ) {
                  e.preventDefault();
                  send();
                }
              }}
              placeholder="@Engineering tolong perbaiki cepat untuk WO ini..."
            />
          </div>

          <div className="wo-chat-send-wrap-v3">
            <button
              type="button"
              className="wo-btn wo-primary"
              disabled={busy || !message.trim()}
              onClick={send}
            >
              {busy ? "MENGIRIM..." : "KIRIM"}
            </button>
          </div>
        </div>

        {statusText && (
          <div className="wo-chat-status-v3">
            {statusText}
          </div>
        )}

        <div className="wo-chat-example-v3">
          Contoh:
          {" "}
          <b>@Engineering</b>
          {" "}
          tolong perbaiki cepat untuk No. WO ini.
          {" | "}
          <b>@Quality</b>
          {" "}
          mohon segera cek hasil Engineering.
        </div>
      </div>

      <div className="wo-card">
        <div className="wo-chat-filter-v3">
          <div className="wo-chat-filter-tags-v3">
            <button
              type="button"
              className={
                `wo-chat-filter-btn-v3 ${
                  filterRole === "" ? "active" : ""
                }`
              }
              onClick={() => setFilterRole("")}
            >
              Semua
            </button>

            {tags.map((tag) => (
              <button
                type="button"
                key={tag.role}
                className={
                  `wo-chat-filter-btn-v3 ${
                    filterRole === tag.role ? "active" : ""
                  }`
                }
                onClick={() => setFilterRole(tag.role)}
              >
                {tag.label}
              </button>
            ))}
          </div>

          <div className="wo-chat-search-v3">
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") doSearch();
              }}
              placeholder="Cari pesan / No. WO / user / part..."
            />

            <button
              type="button"
              className="wo-btn wo-muted"
              onClick={doSearch}
            >
              Cari
            </button>
          </div>
        </div>

        <div className="wo-chat-feed-v3">
          {rows.map((m) => {
            const mine =
              String(m.sender_username || "") ===
              String(myName);

            return (
              <div
                key={m.id}
                className={
                  `wo-global-msg-v3 ${
                    mine ? "mine" : ""
                  }`
                }
              >
                <div className="wo-global-msg-meta-v3">
                  <div>
                    <b>{m.sender_username || "-"}</b>
                    <span>
                      {" → "}
                      {m.mention_tag ||
                        `@${m.target_role || "-"}`}
                    </span>
                  </div>

                  <small>
                    {m.created_at
                      ? new Date(
                          m.created_at
                        ).toLocaleString("id-ID")
                      : ""}
                  </small>
                </div>

                {m.wo_no && (
                  <div className="wo-global-ref-v3">
                    <b>{m.wo_no}</b>
                    {m.nama_part && (
                      <span>{m.nama_part}</span>
                    )}
                    {m.line && (
                      <span>Line {m.line}</span>
                    )}
                  </div>
                )}

                <p>{m.message}</p>
              </div>
            );
          })}

          {!rows.length && (
            <div className="wo-empty-state">
              Belum ada percakapan Chat Center.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* END SIP_WO_CHAT_CENTER_V3_FRONTEND */

function WoChatModalV2({ wo, defaultRole, onClose }) {
  const [targetRole, setTargetRole] = useState(defaultRole || "ENGINEERING");
  const [users, setUsers] = useState([]);
  const [targetUser, setTargetUser] = useState("");
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const me = getStoredUser();
  const myName = me?.username || me?.name || "admin";

  const loadMessages = async () => {
    const x = await woV2Fetch(`/${wo.id}/chat`);
    setMessages(x.data || []);
    await woV2Fetch(`/${wo.id}/chat/read`, {method:"POST", body:"{}"}).catch(()=>{});
  };

  const loadUsers = async (role = targetRole) => {
    const x = await woV2Fetch(`/chat/users?role=${encodeURIComponent(role)}`);
    setUsers(x.data || []);
  };

  useEffect(() => {
    loadMessages().catch(()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wo.id]);

  useEffect(() => {
    setTargetUser("");
    loadUsers(targetRole).catch(()=>setUsers([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetRole]);

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      const selectedUser = users.find((x)=>String(x.id)===String(targetUser));
      await woV2Fetch(`/${wo.id}/chat`, {
        method:"POST",
        body:JSON.stringify({
          target_role: targetRole,
          target_user_id: selectedUser?.id || null,
          target_username: selectedUser?.username || null,
          message:text.trim(),
        }),
      });
      setText("");
      await loadMessages();
    } catch (e) {
      alert(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="wo-modal-overlay-v2" onClick={onClose}>
      <div className="wo-modal-v2 wo-chat-modal-v2" onClick={(e)=>e.stopPropagation()}>
        <div className="wo-modal-head-v2">
          <div><h3>💬 Chat WO {wo.wo_no}</h3><p>Pesan tersimpan per Work Order.</p></div>
          <button className="wo-btn wo-muted" onClick={onClose}>✕</button>
        </div>

        <div className="wo-chat-target-v2">
          <div className="wo-field">
            <label>Tujuan Bagian</label>
            <select value={targetRole} onChange={(e)=>setTargetRole(e.target.value)}>
              <option value="PRODUCTION">Produksi</option>
              <option value="PPIC">PPIC</option>
              <option value="ENGINEERING">Engineering</option>
              <option value="QUALITY">Quality</option>
            </select>
          </div>

          <div className="wo-field">
            <label>User Tujuan (opsional)</label>
            <select value={targetUser} onChange={(e)=>setTargetUser(e.target.value)}>
              <option value="">Semua user pada bagian</option>
              {users.map((u)=><option value={u.id} key={`${u.id}-${u.username}`}>{u.username}</option>)}
            </select>
          </div>
        </div>

        <div className="wo-chat-list-v2">
          {messages.map((m) => {
            const mine = String(m.sender_username || "") === String(myName);
            return (
              <div className={`wo-chat-msg-v2 ${mine ? "mine" : ""}`} key={m.id}>
                <div><b>{m.sender_username || "-"}</b> <span>→ {m.target_username || m.target_role}</span></div>
                <p>{m.message}</p>
                <small>{m.created_at ? new Date(m.created_at).toLocaleString("id-ID") : ""}</small>
              </div>
            );
          })}
          {!messages.length && <div className="wo-empty-state">Belum ada chat pada WO ini.</div>}
        </div>

        <div className="wo-chat-compose-v2">
          <textarea
            value={text}
            onChange={(e)=>setText(e.target.value)}
            onKeyDown={(e)=>{
              if (e.key==="Enter" && !e.shiftKey) {
                e.preventDefault();
                send();
              }
            }}
            placeholder="Tulis pesan... Enter untuk kirim, Shift+Enter baris baru"
          />
          <button className="wo-btn wo-primary" disabled={busy || !text.trim()} onClick={send}>
            {busy ? "Mengirim..." : "KIRIM"}
          </button>
        </div>
      </div>
    </div>
  );
}

function WoFilesModalV2({ wo, allowUpload, onClose }) {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const cameraRef = React.useRef(null);
  const fileRef = React.useRef(null);

  const load = async () => {
    const x = await woV2Fetch(`/${wo.id}/attachments`);
    setRows(x.data || []);
  };

  useEffect(() => {
    load().catch(()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wo.id]);

  const uploadFiles = async (files) => {
    const arr = Array.from(files || []);
    if (!arr.length) return;
    if (rows.length + arr.length > 10) return alert("Maksimal 10 foto per WO.");

    setBusy(true);
    try {
      const fd = new FormData();
      arr.forEach((f)=>fd.append("files", f));
      await woV2Fetch(`/${wo.id}/attachments`, {method:"POST", body:fd});
      await load();
    } catch (e) {
      alert(e.message);
    } finally {
      setBusy(false);
      if (cameraRef.current) cameraRef.current.value="";
      if (fileRef.current) fileRef.current.value="";
    }
  };

  const viewFile = async (r) => {
    try {
      const res = await fetch(`${API_V2}/${wo.id}/attachments/${r.id}/file`, {
        headers: woV2AuthHeaders(),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener,noreferrer");
      setTimeout(()=>URL.revokeObjectURL(url), 60000);
    } catch (e) {
      alert(`Gagal buka foto: ${e.message}`);
    }
  };

  const remove = async (r) => {
    if (!window.confirm(`Hapus foto ${r.original_name || ""}?`)) return;
    await woV2Fetch(`/${wo.id}/attachments/${r.id}`, {method:"DELETE"});
    await load();
  };

  return (
    <div className="wo-modal-overlay-v2" onClick={onClose}>
      <div className="wo-modal-v2" onClick={(e)=>e.stopPropagation()}>
        <div className="wo-modal-head-v2">
          <div><h3>📷 Foto Engineering - {wo.wo_no}</h3><p>Maks. 10 foto, masing-masing 5 MB. JPG/JPEG/PNG/WEBP.</p></div>
          <button className="wo-btn wo-muted" onClick={onClose}>✕</button>
        </div>

        {allowUpload && (
          <div className="wo-actions">
            <input ref={cameraRef} hidden type="file" accept="image/*" capture="environment" onChange={(e)=>uploadFiles(e.target.files)} />
            <input ref={fileRef} hidden type="file" accept=".jpg,.jpeg,.png,.webp,image/*" multiple onChange={(e)=>uploadFiles(e.target.files)} />
            <button className="wo-btn wo-primary" disabled={busy} onClick={()=>cameraRef.current?.click()}>📷 Kamera</button>
            <button className="wo-btn wo-muted" disabled={busy} onClick={()=>fileRef.current?.click()}>📎 File / Gallery</button>
          </div>
        )}

        <div className="wo-files-grid-v2">
          {rows.map((r)=>(
            <div className="wo-file-card-v2" key={r.id}>
              <div className="wo-file-icon-v2">🖼️</div>
              <b>{r.original_name || `Foto ${r.id}`}</b>
              <small>{Math.round(Number(r.file_size || 0)/1024)} KB • {r.uploaded_by || "-"}</small>
              <div className="wo-actions">
                <button className="wo-btn wo-primary" onClick={()=>viewFile(r)}>Lihat</button>
                {allowUpload && <button className="wo-btn wo-danger" onClick={()=>remove(r)}>Hapus</button>}
              </div>
            </div>
          ))}
          {!rows.length && <div className="wo-empty-state">Belum ada foto Engineering.</div>}
        </div>
      </div>
    </div>
  );
}

function WoHistoryModalV2({ wo, onClose }) {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    woV2Fetch(`/${wo.id}/activity`)
      .then((x)=>setRows(x.data || []))
      .catch(()=>setRows([]));
  }, [wo.id]);

  return (
    <div className="wo-modal-overlay-v2" onClick={onClose}>
      <div className="wo-modal-v2" onClick={(e)=>e.stopPropagation()}>
        <div className="wo-modal-head-v2">
          <div><h3>📜 Activity History - {wo.wo_no}</h3><p>Riwayat workflow dan aktivitas WO.</p></div>
          <button className="wo-btn wo-muted" onClick={onClose}>✕</button>
        </div>

        <div className="wo-history-v2">
          {rows.map((r)=>(
            <div className="wo-history-item-v2" key={r.id}>
              <div>
                <b>{r.action_type}</b>
                <span>{r.from_stage || "-"} → {r.to_stage || "-"}</span>
                {r.note && <p>{r.note}</p>}
              </div>
              <div>
                <b>{r.actor_username || "-"}</b>
                <small>{r.created_at ? new Date(r.created_at).toLocaleString("id-ID") : ""}</small>
              </div>
            </div>
          ))}
          {!rows.length && <div className="wo-empty-state">Belum ada history V2.</div>}
        </div>
      </div>
    </div>
  );
}

/* END SIP_WO_WORKFLOW_V2_HELPERS */
